<template>
  <div v-if="shipmentData" class="main-container-shipmentinfo">
    <div class="inner-container" id="printable-content">
        <div class="confirm-container-main">
                <div class="close-shipment-info-container">
                    <!-- <button class="close-shipment-info" @click="closeShipmentInfo()">Close</button> -->
                    <svg class="close-shipment-info" @click="closeShipmentInfo()" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                        <path d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z" fill="#32ccfe" class="fill-000000"></path>
                        <path d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z" fill="#32ccfe" class="fill-000000"></path>
                    </svg>
                </div>
                
                <div class="confirm-header-container">
                    <h1 class="package-details-header">Package Details {{shipmentData.shipmentID}}</h1>
                    <img src="../../assets/LREXDinoFooter.jpg" alt="">
                </div>

                <div class="inner-overflow-container" id="inner-overflow-container">
                    <div class="label-container" id="label-container" v-if="labelData != null">
                        <shipment-label :baseLabelData="labelData" />
                    </div>

                    <button @click="ShowLabelRender()" v-if="showPdfRenderer == true" class="print-button" style="margin-top: 5px">Close Label</button>
                    <div class="pdf-render-container" v-if="(shipmentData.signedLabelURL) && showPdfRenderer">
                        <pdf-label-renderer :urls="[this.shipmentData.signedLabelURL]"/>
                    </div>

                    <div v-if="(AdminUser || InternalAdmin) && (isManifestDashboard)" class="confirmContainerInner">
                        <div class="confirm-container-address">
                            <div class="confirmContainerInner1 activity-update">
                                <select required name="Activity" id="Activity" v-model="activityUpdateValue">
                                    <option value="2012">Not Ready</option>
                                    <option value="12">Warehouse</option>
                                    <!-- <option value="11">Pickup</option> -->
                                </select>
                                <button class="print-button" @click="updateShipmentActivityStatus()" style="white-space: nowrap;">Update Activity</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="ManifestAdmin" class="manifest-admin-box">
                        <button 
                            class="print-button"
                            style="margin-top: 10px"
                            @click="toggleManifestAdminBox = !toggleManifestAdminBox"
                        >
                            {{ toggleManifestAdminBox ? "Hide Manifest Admin Actions" : "Show Manifest Admin Actions" }}
                        </button>

                        <div v-if="toggleManifestAdminBox" class="manifest-admin-content">
                            <button 
                                v-if="(shipmentData.currentKey != null) || (shipmentData.inTransitKey != null)"
                                v-show="toggleClearFromManifest == false"
                                class="print-button cancel-button"
                                style="margin-top: 10px"
                                @click="toggleClearFromManifestFunc()"
                            >
                                Clear Shipment From Manifest
                            </button>

                            <button 
                                v-if="(shipmentData.currentKey != null) || (shipmentData.inTransitKey != null)"
                                v-show="toggleClearFromManifest == true"
                                class="print-button cancel-button"
                                style="margin-top: 10px"
                                @click="toggleClearFromManifestFunc()"
                            >
                                Cancel Clear From Manifest
                            </button>

                            <div style="margin-left: 25px; margin-bottom: 5px">
                                <div v-if="toggleClearFromManifest" class="add-comment-container">
                                    <textarea 
                                        type="text"
                                        cols="50"
                                        rows="5"
                                        maxlength="50"
                                        placeholder="Add Comment"
                                        v-model="voidComment"
                                    ></textarea>

                                    <button 
                                        class="internal-comment-button"
                                        @click="clearFromManifestUpdateActivity()"
                                    >
                                        Confirm Clear From Manifest
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
               
                    <div class="confirmContainerInner">
                        <div class="confirm-container-address">
                            <div v-if="!updateServiceAddressToggleValue" class="confirmContainerInner1">
                                <div class="confirm-svg">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54">
                                        <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                            <g>
                                            <g>
                                                <polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25"/>
                                                <line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23"/>
                                                <polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23"/>
                                                <line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23"/>
                                                <line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34"/>
                                            </g>
                                            <path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12"/>
                                            <path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49"/>
                                            <path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12"/>
                                            <path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z"/>
                                            <path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03"/>
                                            <path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <h2>Delivery Address</h2>
                                </div>
                                
                                <div  class="confirmLabelContainer">
                                    <p name="companyName">{{shipmentData.serviceAddress.address.companyName}}</p>
                                </div>
                                
                                <div  class="confirmLabelContainer">
                                    <p name="address1">{{shipmentData.serviceAddress.address.address1}}</p>
                                </div>
                                
                                <div v-if="(shipmentData.serviceAddress.address.address2)" class="confirmLabelContainer">
                                    <p name="address2">{{shipmentData.serviceAddress.address.address2}}</p>
                                </div>
                                
                                <div  class="confirmLabelContainer">
                                    <p name="city">{{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}} {{shipmentData.serviceAddress.address.zipCode}}</p>
                                </div>

                                <div  class="confirmLabelContainer">
                                    <p name="phone">{{shipmentData.serviceAddress.address.phone}}</p>
                                </div>

                                <div v-if="(shipmentData.serviceAddress.address.attention)" class="confirmLabelContainer">
                                    <label for="contactName">Contact Name:</label>
                                    <p style="white-space: nowrap;" name="contactName">{{shipmentData.serviceAddress.address.attention}}</p>
                                </div>

                                <div  class="confirmLabelContainer">
                                    <p name="route">Route: <span style="font-weight: bold;">{{shipmentData.serviceAddress.address.routeCode}}</span></p>
                                </div>

                                <button v-if="(AdminUser || InternalAdmin)" @click="toggleMapView = !toggleMapView" class="print-button" style="margin-left: 0px">Toggle Map View</button>
                            </div>

                            <div v-if="updateServiceAddressToggleValue" class="confirmContainerInner1">
                                <div class="auto-complete-container">
                                    <AWSAutoComplete @GetSelectedAddressData="GetSelectedAddressData($event)" @customAddressToggle="customAddressToggle($event)" :placeHolder="placeHolder" />
                                </div>
                                <div class="confirm-svg">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54">
                                        <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                            <g>
                                            <g>
                                                <polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25"/>
                                                <line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23"/>
                                                <polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23"/>
                                                <line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23"/>
                                                <line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34"/>
                                            </g>
                                            <path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12"/>
                                            <path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49"/>
                                            <path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12"/>
                                            <path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z"/>
                                            <path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03"/>
                                            <path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <h2>Delivery Address</h2>
                                </div>

                                <div class="confirmLabelContainer">
                                    <input type="text" v-model="shipmentData.serviceAddress.address.companyName">
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <input type="text" id="address1" disabled v-model="shipmentData.serviceAddress.address.address1">
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <input placeholder="Suite/Building" type="text" v-model="shipmentData.serviceAddress.address.address2">
                                </div>

                                <div class="confirmLabelContainer">
                                    <input type="text" id="city" disabled v-model="shipmentData.serviceAddress.address.city" placeholder="City">
                                </div>

                                <div class="confirmLabelContainer">
                                    <select disabled required name="state" id="state" v-model="shipmentData.serviceAddress.address.state">
                                        <option value="" disabled selected>State</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </select>
                                </div>

                                <div class="confirmLabelContainer">
                                    <input type="text" id="zipcode" disabled v-model="shipmentData.serviceAddress.address.zipCode" placeholder="Zip Code">
                                </div>

                                <div class="confirmLabelContainer">
                                    <input type="text" id="phone" v-model="shipmentData.serviceAddress.address.phone" placeholder="Phone">
                                </div>

                                <div class="confirmLabelContainer">
                                    <label for="contactName">Contact Name:</label>
                                    <input type="text" v-model="shipmentData.serviceAddress.address.attention">
                                </div>
                            </div>

                            <div v-if="!updatePickupAddressToggleValue" class="confirmContainerInner1">
                                <div class="confirm-svg">
                                        <svg version="1.1" id="Layer_2_00000011015521083262897090000013693107950429558190_"
                                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 320.6 219.7"
                                                style="enable-background:new 0 0 320.6 219.7;" xml:space="preserve">
                                            <g id="_Ñëîé_1">
                                                <g>
                                                    <g>
                                                        <polyline class="st1" points="59.6,21 93.4,54.7 21,127.6 5,111.7 			"/>
                                                        <path class="st1" d="M101.7,187l1.4,1.2l4.7,4.7c4.6,4.6,5.4,12,1.3,17c-4.7,5.8-13.2,6.1-18.4,1l-22.1-21.7
                                                            c-5-5-9.4-10.6-13-16.6c-5-8.4-8.4-17.7-10.2-27.3L43.1,132l-13.3-13.2"/>
                                                        <path class="st1" d="M106.1,191.2l20,19.9c4.9,4.8,12.7,4.8,17.5-0.1c4.8-4.9,4.8-12.7-0.1-17.5l-1-1l-4.4-4.3l-2.5-2.5"/>
                                                        <path class="st1" d="M144.7,194.8l14,13.9l-0.7-0.7l1.9,1.9c4.9,4.8,12.7,4.8,17.6-0.1c2.7-2.7,3.8-6.3,3.5-9.8
                                                            c-0.2-2.8-1.4-5.6-3.6-7.8l-9.1-8.7"/>
                                                        <path class="st1" d="M85.1,63.1l15.1,14.9l11.4-3.4c12.2-3.7,25.5-1.7,36.1,5.3l51,33.9c2.1,1.4,3,3.7,2.8,6c-0.1,1-0.4,2-1,2.9
                                                            c-5.9,9-18.2,11.3-26.9,5L159,117.4c-1.2-0.8-2.5-1.3-3.8-1.4c-2.4-0.2-4.8,0.7-6.5,2.5c-2.8,3.1-2.7,7.8,0.3,10.8l62,61.6
                                                            c5.2,5.2,4.9,13.8-1,18.6c-5,3.9-12.2,3.2-16.8-1.3l-14.5-14.3"/>
                                                    </g>
                                                    <g>
                                                        <polyline class="st1" points="237.1,206.3 315.6,206.3 315.6,5 115.9,5 115.9,49.6 			"/>
                                                        <g>
                                                            <line class="st1" x1="258.2" y1="177.4" x2="253.3" y2="177.4"/>
                                                            <line class="st1" x1="285.9" y1="177.4" x2="281" y2="177.4"/>
                                                        </g>
                                                    </g>
                                                    <polyline class="st1" points="242.2,5 242.2,55.2 213.6,38.6 185,55.2 185,5 		"/>
                                                </g>
                                            </g>
                                        </svg>
                                        <h2>Pickup Address</h2>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="companyName">{{shipmentData.deliveryPickup.address.companyName}}</p>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="address1">{{shipmentData.deliveryPickup.address.address1}}</p>
                                </div>
                                
                                <div v-if="shipmentData.deliveryPickup.address.address2" class="confirmLabelContainer">
                                    <p name="address2">{{shipmentData.deliveryPickup.address.address2}}</p>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="city">{{shipmentData.deliveryPickup.address.city}}, {{shipmentData.deliveryPickup.address.state}}, {{shipmentData.deliveryPickup.address.zipCode}}</p>
                                </div>

                                <div class="confirmLabelContainer">
                                    <p name="phone">{{shipmentData.deliveryPickup.address.phone}}</p>
                                </div>

                                <div v-if="shipmentData.deliveryPickup.address.attention" class="confirmLabelContainer">
                                    <label for="contactName">Contact Name:</label>
                                    <p style="white-space: nowrap;" name="contactName">{{shipmentData.deliveryPickup.address.attention}}</p>
                                </div>

                                <div class="confirmLabelContainer">
                                    <p name="route">Route: <span style="font-weight: bold;">{{shipmentData.deliveryPickup.address.routeCode}}</span></p>
                                </div>
                            </div>

                            <div v-if="updatePickupAddressToggleValue" class="confirmContainerInner1">
                                <div class="auto-complete-container">
                                    <AWSAutoComplete @GetSelectedAddressData="GetSelectedAddressData($event)" @customAddressToggle="customAddressToggle($event)" :placeHolder="placeHolder" />
                                </div>
                                <div class="confirm-svg">
                                        <svg version="1.1" id="Layer_2_00000011015521083262897090000013693107950429558190_"
                                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 320.6 219.7"
                                                style="enable-background:new 0 0 320.6 219.7;" xml:space="preserve">
                                            <g id="_Ñëîé_1">
                                                <g>
                                                    <g>
                                                        <polyline class="st1" points="59.6,21 93.4,54.7 21,127.6 5,111.7 			"/>
                                                        <path class="st1" d="M101.7,187l1.4,1.2l4.7,4.7c4.6,4.6,5.4,12,1.3,17c-4.7,5.8-13.2,6.1-18.4,1l-22.1-21.7
                                                            c-5-5-9.4-10.6-13-16.6c-5-8.4-8.4-17.7-10.2-27.3L43.1,132l-13.3-13.2"/>
                                                        <path class="st1" d="M106.1,191.2l20,19.9c4.9,4.8,12.7,4.8,17.5-0.1c4.8-4.9,4.8-12.7-0.1-17.5l-1-1l-4.4-4.3l-2.5-2.5"/>
                                                        <path class="st1" d="M144.7,194.8l14,13.9l-0.7-0.7l1.9,1.9c4.9,4.8,12.7,4.8,17.6-0.1c2.7-2.7,3.8-6.3,3.5-9.8
                                                            c-0.2-2.8-1.4-5.6-3.6-7.8l-9.1-8.7"/>
                                                        <path class="st1" d="M85.1,63.1l15.1,14.9l11.4-3.4c12.2-3.7,25.5-1.7,36.1,5.3l51,33.9c2.1,1.4,3,3.7,2.8,6c-0.1,1-0.4,2-1,2.9
                                                            c-5.9,9-18.2,11.3-26.9,5L159,117.4c-1.2-0.8-2.5-1.3-3.8-1.4c-2.4-0.2-4.8,0.7-6.5,2.5c-2.8,3.1-2.7,7.8,0.3,10.8l62,61.6
                                                            c5.2,5.2,4.9,13.8-1,18.6c-5,3.9-12.2,3.2-16.8-1.3l-14.5-14.3"/>
                                                    </g>
                                                    <g>
                                                        <polyline class="st1" points="237.1,206.3 315.6,206.3 315.6,5 115.9,5 115.9,49.6 			"/>
                                                        <g>
                                                            <line class="st1" x1="258.2" y1="177.4" x2="253.3" y2="177.4"/>
                                                            <line class="st1" x1="285.9" y1="177.4" x2="281" y2="177.4"/>
                                                        </g>
                                                    </g>
                                                    <polyline class="st1" points="242.2,5 242.2,55.2 213.6,38.6 185,55.2 185,5 		"/>
                                                </g>
                                            </g>
                                        </svg>
                                        <h2>Pickup Address</h2>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <input type="text" placeholder="Company Name" v-model="shipmentData.deliveryPickup.address.companyName">
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <input type="text" placeholder="Address" disabled id="address1" v-model="shipmentData.deliveryPickup.address.address1">
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <input type="text" placeholder="Suite/Building" v-model="shipmentData.deliveryPickup.address.address2">
                                </div>

                                <div class="confirmLabelContainer">
                                    <input placeholder="City" type="text" disabled id="city" v-model="shipmentData.deliveryPickup.address.city">
                                </div>

                                <div class="confirmLabelContainer">
                                    <select disabled required name="state" id="state" v-model="shipmentData.deliveryPickup.address.state">
                                        <option value="" disabled selected>State</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </select>
                                </div>

                                <div class="confirmLabelContainer">
                                    <input type="text" placeholder="Phone" id="phone" v-model="shipmentData.deliveryPickup.address.phone">
                                </div>

                                <div class="confirmLabelContainer">
                                    <input type="text" disabled id="zipcode" placeholder="ZipCode" v-model="shipmentData.deliveryPickup.address.zipCode">
                                </div>

                                <div class="confirmLabelContainer">
                                    <label for="contactName">Contact Name:</label>
                                    <input type="text" v-model="shipmentData.deliveryPickup.address.attention">
                                </div>
                            </div>
                        </div>

                        <div class="confirmContainerInner2">
                            <div class="confirm-svg notifications">
                                <svg data-name="Livello 1" viewBox="10 12.5 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M1 33A32 32 0 1 0 33 1 32 32 0 0 0 1 33Z" fill="none" class="fill-000000"></path><rect height="24.18" rx="1.48" ry="1.48" width="32" x="17" y="21" stroke-miterlimit="10" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></rect><path d="M48.44 21.83 37.53 33.54a6.27 6.27 0 0 1-9.07 0l-10.9-11.7M39.19 31.75l8.96 12.76M26.98 31.88 17.7 44.51" stroke-linejoin="round" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></path></svg>
                                <h2>Notifications</h2>
                            </div>
                            
                            <div v-if="shipmentData.deliveryEmail && shipmentData.deliveryEmail.length > 0" class="confirmLabelContainer2">
                                <label for="deliveryemail">Delivery Email:</label>
                                <div class="notificationArray" name="deliveryemail" v-for="(email, index) in shipmentData.deliveryEmail" :key="index">
                                        <p>{{shipmentData.deliveryEmail[index]}}</p>
                                </div>
                            </div>

                            <div v-if="shipmentData.deliveryPhone && shipmentData.deliveryPhone.length > 0" class="confirmLabelContainer2">
                                <label for="deliveryphone">Delivery Phone:</label>
                                <div class="notificationArray" name="deliveryphone" v-for="(email, index) in shipmentData.deliveryPhone" :key="index">
                                        <p>{{shipmentData.deliveryPhone[index]}}</p>
                                </div>
                            </div>

                            <div v-if="shipmentData.nonDeliveryEmail && shipmentData.nonDeliveryEmail.length > 0" class="confirmLabelContainer2">
                                <label for="nonDeliveryemail">Non Delivery Email:</label>
                                <div class="notificationArray" name="nonDeliveryemail" v-for="(email, index) in shipmentData.nonDeliveryEmail" :key="index">
                                        <p>{{shipmentData.nonDeliveryEmail[index]}}</p>
                                </div>
                            </div>

                            <div v-if="shipmentData.nonDeliveryPhone && shipmentData.nonDeliveryPhone.length > 0" class="confirmLabelContainer2">
                                <label for="nonDeliveryphone">Non Delivery Phone:</label>
                                <div class="notificationArray" name="nonDeliveryphone" v-for="(email, index) in shipmentData.nonDeliveryPhone" :key="index">
                                        <p>{{shipmentData.nonDeliveryPhone[index]}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="toggleMapView && shipmentData">
                        <LocationMap :showPickupLogic="false" :shipmentData="shipmentData"/>
                    </div>

                        <div class="weight-container">
                            <div v-if="shipmentData.deliveryInstructions" class="confirmLabelContainer">
                                <label style="font-weight: bold; white-space: nowrap;" for="DeliveryInstructions">Delivery Instructions:</label>
                                <p style="text-align: left;" name="DeliveryInstructions">{{shipmentData.deliveryInstructions}}</p>
                            </div>

                            <div v-if="shipmentData.ref1" class="confirmLabelContainer" style="flex-wrap: wrap; word-break: break-word; max-width: 100%;">
                                <label style="font-weight: bold; white-space: nowrap;" for="Ref1">Reference:</label>
                                <p style="text-align: left;" name="Ref1">{{shipmentData.ref1}}</p>
                            </div>

                            <div v-if="shipmentData.ref2" class="confirmLabelContainer" style="flex-wrap: wrap; word-break: break-word; max-width: 100%;">
                                <label style="font-weight: bold; white-space: nowrap;" for="Ref2">Reference:</label>
                                <p style="text-align: left;" name="Ref2">{{shipmentData.ref2}}</p>
                            </div>

                            <div v-if="shipmentData.ref3" class="confirmLabelContainer" style="flex-wrap: wrap; word-break: break-word; max-width: 100%;">
                                <label style="font-weight: bold; white-space: nowrap;" for="Ref3">Reference:</label>
                                <p style="text-align: left;" name="Ref3">{{shipmentData.ref3}}</p>
                            </div>

                            <div v-if="shipmentData.ref4" class="confirmLabelContainer" style="flex-wrap: wrap; word-break: break-word; max-width: 100%;">
                                <label style="font-weight: bold; white-space: nowrap;" for="Ref4">Reference:</label>
                                <p style="text-align: left;" name="Ref4">{{shipmentData.ref4}}</p>
                            </div>

                            <div v-if="shipmentData.ref5" class="confirmLabelContainer" style="flex-wrap: wrap; word-break: break-word; max-width: 100%;">
                                <label style="font-weight: bold; white-space: nowrap;" for="Ref5">Reference:</label>
                                <p style="text-align: left;" name="Ref5">{{shipmentData.ref5}}</p>
                            </div>

                            <div v-if="shipmentData.additionalRefs" style="display: flex; flex-direction: column; flex-wrap: wrap; word-break: break-word; max-width: 100%;">
                                <label style="font-weight: bold; white-space: nowrap;" for="additionalRefs">Additional References:</label>
                                <p v-for="(ref, index) in shipmentData.additionalRefs"
                                    :key="index"
                                    style="margin: 0; text-align: left;">
                                    {{ ref }}
                                </p>
                            </div>

                            <div class="confirmLabelContainer">
                                <label style="font-weight: bold;" for="service">Service:</label>
                                <p name="service">{{shipmentServiceType}}</p>
                            </div>

                            <div v-if="shipmentData.externalTrackingNumber && ((AdminUser) || (InternalAdmin))" class="confirmLabelContainer">
                                <label style="font-weight: bold;" for="service">External Tracking:</label>
                                <p name="service">{{shipmentData.externalTrackingNumber}}</p>
                            </div>

                            <div v-if="shipmentData.username && ((AdminUser) || (InternalAdmin) || (CustomerAdmin))" class="confirmLabelContainer">
                                <label style="font-weight: bold;" for="service">User Name:</label>
                                <p name="service">{{shipmentData.username}}</p>
                            </div>

                            <div v-if="shipmentData.accountNo && ((AdminUser) || (InternalAdmin) || (CustomerAdmin))" class="confirmLabelContainer">
                                <label style="font-weight: bold;" for="service">Account No:</label>
                                <p name="service">{{shipmentData.accountNo}}</p>
                            </div>

                            <div v-if="shipmentData.additionalServices && shipmentData.additionalServices.length > 0" class="confirmLabelContainer">
                                <label style="font-weight: bold; white-space: nowrap;" for="service">Additional Services:</label>
                                <div v-for="(additionalService, index) in shipmentData.additionalServices" :key="index">
                                    <p style="margin-right: 5px;">{{additionalService}}</p>
                                </div>
                            </div>
                            <div class="confirmLabelContainer">
                                <label style="font-weight: bold; white-space: nowrap;" for="weight">Package Weight:</label>
                                <p name="weight" v-if="shipmentData.weight == 1">Less than 16(lbs)</p>
                                <p v-else name="weight">{{shipmentData.weight}} (lbs)</p>
                            </div>
                            <div v-if="(AdminUser || InternalAdmin) && (shipmentData.inTransitKey != null)" class="add-comment-container">
                                <textarea type="text" cols="50" rows="5" maxlength="50" placeholder="Add Comment" v-model="internalCommentInput"></textarea>
                                <button class="internal-comment-button" @click="addInternalComment()">Add</button>
                            </div>
                        </div>
                            <div>
                                <div class="shipment-history-container">
                                    <div class="history-container" v-for="(items, index) in shipmentData.activity" v-bind:key="items">
                                        <div class="check-mark-container" v-if="shouldShowItem(items)">
                                            <div class="check-mark" :class="{active:index==0, activeLast:index==shipmentData.activity.length - 1}">
                                            <div class="check-mark-item"><img src="../../assets/FinalImages/checkMark.png" alt=""></div>
                                            </div>
                                        </div>
                                        <div class="inner-history-container" v-if="shouldShowItem(items)">
                                            <div class="history-description-container">
                                                <p class="history-description">{{items.description}}</p>
                                                <p class="history-process-date" style="font-size: 12px;">{{ formatLocalTime(items.activityTime) }}</p>
                                            </div>
                                            <div v-if="items.internalComments != 'Scanned out to partner network'">
                                            <p>{{items.internalComments}}</p>
                                            </div>
                                            <div v-if="items.imageKeyID > 0">
                                                <div class="proof-delivery-container">
                                                    <button v-if="items.signedImageURL && !showImage[index]" @click="showImage[index] = true; showLoading(index)" class="main-button-blue-white">Show Image</button>
                                                </div>

                                                <div v-if="showImage[index]" class="image-container">
                                                    <div v-if="loading[index]" class="loading-animation">
                                                    <loading-charts />
                                                    </div>
                                                    <img 
                                                    class="proof-delivery-image" 
                                                    :src="items.signedImageURL" 
                                                    alt="Delivery Image" 
                                                    @load="handleImageLoad(index)"
                                                    />
                                                </div>
                                            </div>

                                            <button
                                                v-if="(AdminUser || InternalAdmin) && items.latitude && items.longitude"
                                                @click="openActivityMap(index)"
                                                class="print-button"
                                                style="margin-left: 0px"
                                            >
                                                Toggle Map View
                                            </button>

                                            <div v-if="toggleMapViewByIndex[index] && shipmentData">
                                                <LocationMap
                                                    :showPickupLogic="false"
                                                    :shipmentData="getMapShipmentData(items)"
                                                />
                                            </div>

                                            <!-- <button v-if="(AdminUser || InternalAdmin) && items.latitude && items.longitude" @click="toggleMapView = !toggleMapView" class="print-button" style="margin-left: 0px">Toggle Map View</button>
                                            <div v-if="toggleMapView && shipmentData">
                                                <LocationMap :showPickupLogic="false" :shipmentData="shipmentData"/>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <loading-charts v-if="loadingData"/>
                    
                    <button v-if="validateCustomAddress" class="print-button create-button" @click="checkAddressCorrection()">Check Address</button>

                    <!-- Activity Product Template for address updates -->
                    <div v-if="updatePickupAddressToggleValue || updateServiceAddressToggleValue" class="activity-product-collapsible">
                        <button
                            type="button"
                            class="activity-product-toggle"
                            @click="showAddressActivityProduct = !showAddressActivityProduct"
                        >
                            <span>{{ showAddressActivityProduct ? '▾' : '▸' }} Activity Product Details</span>
                            <span v-if="shipmentProducts.length" class="activity-product-badge">{{ shipmentProducts.length }} product{{ shipmentProducts.length === 1 ? '' : 's' }}</span>
                        </button>
                        <div v-show="showAddressActivityProduct" class="activity-product-panel">
                            <ActivityProductTemplate
                                :statusID="updateServiceAddressToggleValue ? 61 : 60"
                                :hideApplyButton="true"
                                :shipmentProducts="shipmentData.product || []"
                                @activity-selected="handleActivitySelected"
                                @apply="handleProductTemplate"
                                @products-loaded="handleProductsLoaded"
                            />
                        </div>
                        <div class="activity-product-footer">
                            <button
                                v-if="!validateCustomAddress"
                                type="button"
                                class="print-button create-button"
                                style="margin: 0;"
                                @click="updateShipmentData()"
                            >
                                Update Address
                            </button>
                        </div>
                    </div>

                    <button v-if="(updatePickupAddressToggleValue || updateServiceAddressToggleValue)" class="print-button cancel-button" @click="cancelAddressUpdate()">Cancel Update</button>

                    <!-- Update GeoCode (ManifestDashboard route only) -->
                    <div v-if="isManifestDashboard && (AdminUser || InternalAdmin)" class="geocode-url-container">
                        <p class="geocode-url-label">Update {{ manifestIsDelivery === false ? 'Pickup' : 'Delivery' }} GeoCode</p>
                        <p class="geocode-url-notice">
                            <i class="fa fa-info-circle"></i>
                            Paste a Google Maps URL, Bing Maps URL, or raw coordinates (e.g. <strong>40.4061079, -74.0235619</strong>).
                            <br />
                            <strong>Note:</strong> Bing Maps URLs use the map's center point, so center the map directly on the pin before copying the URL. Google Maps URLs use the pin location automatically.
                        </p>
                        <input
                            type="text"
                            class="geocode-url-input"
                            v-model="geoCodeUrl"
                            placeholder="Paste a Maps URL or lat,lng coordinates"
                        />
                        <button
                            type="button"
                            class="print-button create-button"
                            style="margin: 0;"
                            @click="updateShipmentDataGeoCode()"
                        >
                            Update GeoCode
                        </button>
                    </div>

                    <!-- Address Actions -->
                    <div class="action-groups-row">
                        <div v-if="(shipmentData.inTransitKey != null) && (AdminUser || InternalAdmin)" class="action-group">
                            <h4 class="action-group-title">Address</h4>
                            <div class="action-group-buttons">
                                <button v-if="!updateServiceAddressToggleValue" class="print-button" @click="updatePickupAddressToggle()">Update Pickup</button>
                                <button v-if="!updatePickupAddressToggleValue" class="print-button" @click="updateServiceAddressToggle()">Update Delivery</button>
                            </div>
                        </div>

                        <!-- Update Weight -->
                        <div v-if="(shipmentData.inTransitKey != null) && (AdminUser || InternalAdmin)" class="action-group">
                            <h4 class="action-group-title">Weight</h4>
                            <div class="action-group-buttons">
                                <button class="print-button" @click="toggleUpdateWeight()">
                                    {{ updateWeightToggleValue ? 'Cancel' : 'Update Weight' }}
                                </button>
                            </div>
                        </div>

                        <!-- Charge Same Day -->
                        <div v-if="isSameDayService && (AdminUser || InternalAdmin)" class="action-group">
                            <h4 class="action-group-title">Same Day</h4>
                            <div class="action-group-buttons">
                                <button class="print-button" @click="toggleChargeSameDay()">
                                    {{ chargeSameDayToggleValue ? 'Cancel' : 'Charge Same Day' }}
                                </button>
                            </div>
                        </div>

                        <!-- Return / Reopen -->
                        <div v-if="(AdminUser || InternalAdmin)" class="action-group">
                            <h4 class="action-group-title">Status</h4>
                            <div class="action-group-buttons">
                                <button v-if="(shipmentData.inTransitKey != null) && !toggleReturnToSender" class="print-button cancel-button" @click="toggleReturnToSender = true">Return To Sender</button>
                                <button v-if="(shipmentData.historyKey != null) && !toggleReOpenShipment" class="print-button cancel-button" @click="toggleReOpenShipment = true">Re Open</button>
                            </div>
                        </div>

                        <!-- Print Actions -->
                        <div class="action-group">
                            <h4 class="action-group-title">Print</h4>
                            <div class="action-group-buttons">
                                <button v-if="((shipmentData.currentKey != null) || ((shipmentData.inTransitKey != null) && (AdminUser || InternalAdmin))) && isPickupPage" class="print-button" @click="PrintPickupLabel()">Pickup Label</button>
                                <button v-if="(shipmentData.currentKey != null) || ((shipmentData.inTransitKey != null) && (AdminUser || InternalAdmin))" class="print-button" @click="ShowLabelRender()">Label</button>
                                <button class="print-button" @click="printContent()">Page</button>
                            </div>
                        </div>

                        <!-- Destructive Actions -->
                        <div v-if="(shipmentData.currentKey != null) || ((shipmentData.inTransitKey != null) && (AdminUser || InternalAdmin))" class="action-group action-group-danger">
                            <h4 class="action-group-title">Danger</h4>
                            <div class="action-group-buttons">
                                <button v-show="!toggleVoid" class="print-button cancel-button" @click="toggleVoidShipment()">Void</button>
                                <button v-show="toggleVoid" class="print-button cancel-button" @click="toggleVoidShipment()">Cancel Void</button>
                                <button v-if="(AdminUser || InternalAdmin)" v-show="!toggleCloseOut" class="print-button cancel-button" @click="toggleCloseOutShipment()">Close Out</button>
                                <button v-if="(AdminUser || InternalAdmin)" v-show="toggleCloseOut" class="print-button cancel-button" @click="toggleCloseOutShipment()">Cancel Close Out</button>
                            </div>
                        </div>

                        <!-- Re-Initiate Actions -->
                        <div v-if="(AdminUser || InternalAdmin) && ((shipmentData.currentKey != null) || (shipmentData.inTransitKey != null)) && (shipmentData.service == 'pickup' || shipmentData.service == 'sameday')" class="action-group">
                            <h4 class="action-group-title">Re-Initiate</h4>
                            <div class="action-group-buttons">
                                <button v-if="shipmentData.service == 'pickup'" v-show="!toggleRePickupInitiate" class="print-button cancel-button" @click="toggleRePickupInitiateShipment()">Pickup</button>
                                <button v-if="shipmentData.service == 'pickup'" v-show="toggleRePickupInitiate" class="print-button cancel-button" @click="toggleRePickupInitiateShipment()">Cancel</button>
                                <button v-if="shipmentData.service == 'sameday'" v-show="!toggleReSameDayInitiate" class="print-button cancel-button" @click="toggleReInitiateSameDay()">Same Day</button>
                                <button v-if="shipmentData.service == 'sameday'" v-show="toggleReSameDayInitiate" class="print-button cancel-button" @click="toggleReInitiateSameDay()">Cancel</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="toggleReturnToSender" class="return-to-sender-container">
                        <p>Are you sure you want to return to sender?</p>
                        <div class="activity-product-collapsible" style="margin-left: 0; margin-bottom: 8px;">
                            <button
                                type="button"
                                class="activity-product-toggle"
                                @click="showReturnToSenderActivityProduct = !showReturnToSenderActivityProduct"
                            >
                                <span>{{ showReturnToSenderActivityProduct ? '▾' : '▸' }} Activity Product Details</span>
                                <span v-if="shipmentProducts.length" class="activity-product-badge">{{ shipmentProducts.length }} product{{ shipmentProducts.length === 1 ? '' : 's' }}</span>
                            </button>
                            <div v-show="showReturnToSenderActivityProduct" class="activity-product-panel">
                                <ActivityProductTemplate
                                    :statusID="24"
                                    :hideApplyButton="true"
                                    :shipmentProducts="shipmentData.product || []"
                                    @activity-selected="handleActivitySelected"
                                    @apply="handleProductTemplate"
                                    @products-loaded="handleProductsLoaded"
                                />
                            </div>
                            <div class="activity-product-footer">
                                <button
                                    type="button"
                                    class="print-button create-button"
                                    style="margin: 0;"
                                    @click="returnToSenderUpdateActivity()"
                                >
                                    Return To Sender
                                </button>
                            </div>
                        </div>
                        <div>
                            <button @click="toggleReturnToSender = false" class="print-button cancel-button">Cancel</button>
                        </div>
                    </div>

                    <div v-if="toggleReOpenShipment" class="return-to-sender-container">
                        <p>Are you sure you want to reopen this shipment?</p>
                        <div>
                            <button @click="reOpenShipmentProcess()" class="print-button create-button" style="margin-left: 0;">Confirm</button>
                            <button @click="toggleReOpenShipment = false" class="print-button cancel-button">Cancel</button>
                        </div>
                    </div>

                    <!-- Update Weight -->
                    <div v-if="updateWeightToggleValue" class="shipment-action-overlay">
                      <div class="shipment-action-overlay-panel return-to-sender-container">
                        <p><strong>Update Weight</strong></p>
                        <div class="activity-product-collapsible" style="margin-left: 0; margin-bottom: 8px;">
                            <button
                                type="button"
                                class="activity-product-toggle"
                                @click="showWeightActivityProduct = !showWeightActivityProduct"
                            >
                                <span>{{ showWeightActivityProduct ? '▾' : '▸' }} Activity Product Details</span>
                                <span v-if="shipmentProducts.length" class="activity-product-badge">{{ shipmentProducts.length }} product{{ shipmentProducts.length === 1 ? '' : 's' }}</span>
                            </button>
                            <div v-show="showWeightActivityProduct" class="activity-product-panel">
                                <ActivityProductTemplate
                                    ref="weightActivityProduct"
                                    :statusID="77"
                                    :hideApplyButton="true"
                                    :shipmentProducts="shipmentData.product || []"
                                    @activity-selected="handleActivitySelected"
                                    @apply="handleWeightApply"
                                    @products-loaded="handleProductsLoaded"
                                />
                            </div>
                            <div class="activity-product-footer">
                                <button
                                    type="button"
                                    class="print-button create-button"
                                    style="margin: 0;"
                                    @click="triggerWeightUpdate()"
                                >
                                    Update Weight
                                </button>
                            </div>
                        </div>
                        <div>
                            <button @click="updateWeightToggleValue = false" class="print-button cancel-button">Cancel</button>
                        </div>
                      </div>
                    </div>

                    <!-- Charge Same Day -->
                    <div v-if="chargeSameDayToggleValue" class="shipment-action-overlay">
                      <div class="shipment-action-overlay-panel return-to-sender-container">
                        <p><strong>Charge Same Day</strong></p>
                        <div class="activity-product-collapsible" style="margin-left: 0; margin-bottom: 8px;">
                            <button
                                type="button"
                                class="activity-product-toggle"
                                @click="showSameDayActivityProduct = !showSameDayActivityProduct"
                            >
                                <span>{{ showSameDayActivityProduct ? '▾' : '▸' }} Same Day Charges</span>
                            </button>
                            <div v-show="showSameDayActivityProduct" class="activity-product-panel">
                                <ActivityProductTemplate
                                    ref="sameDayActivityProduct"
                                    :statusID="sameDayStatusID"
                                    :hideApplyButton="true"
                                    :shipmentProducts="shipmentData.product || []"
                                    @activity-selected="handleActivitySelected"
                                    @apply="handleSameDayApply"
                                    @products-loaded="handleProductsLoaded"
                                />
                            </div>
                            <div class="activity-product-footer">
                                <button
                                    type="button"
                                    class="print-button create-button"
                                    style="margin: 0;"
                                    @click="triggerSameDayCharge()"
                                >
                                    Charge Same Day
                                </button>
                            </div>
                        </div>
                        <div>
                            <button @click="chargeSameDayToggleValue = false" class="print-button cancel-button">Cancel</button>
                        </div>
                      </div>
                    </div>

                    <div v-if="toggleVoid" style="margin-left: 25px; margin-bottom: 5px">
                        <div class="add-comment-container">
                            <textarea type="text" cols="50" rows="5" maxlength="50" placeholder="Add Comment" v-model="voidComment"></textarea>
                            <button class="internal-comment-button" @click="voidShipmentUpdateActivity()">Confirm Void</button>
                        </div> 
                    </div>

                    <div v-if="(AdminUser || InternalAdmin) && toggleCloseOut" style="margin-left: 25px; margin-bottom: 5px">
                        <div class="add-comment-container">
                            <textarea type="text" cols="50" rows="5" maxlength="50" placeholder="Add Comment" v-model="closeShipmentComment"></textarea>
                            <button class="internal-comment-button" @click="closeShipmentUpdateActivity()">Process Close Out</button>
                        </div> 
                    </div>

                    <div v-if="(AdminUser || InternalAdmin) && toggleRePickupInitiate" style="margin-left: 25px; margin-bottom: 5px">
                        <div class="add-comment-container">
                            <textarea type="text" cols="50" rows="5" maxlength="50" placeholder="Add Comment" v-model="rePickupComment"></textarea>
                            <button class="internal-comment-button" @click="rePickupInitiateShipmentUpdateActivity()">Re-Initiate Pickup</button>
                        </div> 
                    </div>

                    <div v-if="(AdminUser || InternalAdmin) && toggleReSameDayInitiate" style="margin-left: 25px; margin-bottom: 5px">
                        <div class="add-comment-container">
                            <textarea type="text" cols="50" rows="5" maxlength="50" placeholder="Add Comment" v-model="rePickupComment"></textarea>
                            <button class="internal-comment-button" @click="reSameDayInitiateShipmentUpdateActivity()">Re-Initiate Same Day</button>
                        </div> 
                    </div>
            </div>
    </div>
    <loading-data v-if="loadingData"/>
  </div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
<AWSAddressCorrection v-if="updatePickupAddressToggleValue && validateCustomAddress" @useEnteredAddress="useEnteredAddress($event)" @setCustomAddress="setCustomAddress($event)" @useCorrectedAddress="useCorrectedAddress($event)" :customAddress="userCustomAddress" :shipmentData="shipmentData.deliveryPickup.address"/>
<AWSAddressCorrection v-if="updateServiceAddressToggleValue && validateCustomAddress" @useEnteredAddress="useEnteredAddress($event)" @setCustomAddress="setCustomAddress($event)" @useCorrectedAddress="useCorrectedAddress($event)" :customAddress="userCustomAddress" :shipmentData="shipmentData.serviceAddress.address"/>

</template>

<script>
import {API, Auth} from 'aws-amplify';
import AWS from 'aws-sdk';
import awsconfig from '../../aws-exports';
import AlertUser from '../../components/Popups/AlertUser.vue';
import ShipmentLabel from '../ShipmentDashboard/ShipmentLabel.vue';
import LoadingCharts from '../ShipmentDashboard/LoadingCharts.vue';
import LoadingData from '../Popups/LoadingData.vue';
// import {updateShipmentActivity, createShipmentLabelLambda, getMergedLabelsLREX, updateShipmentData, createLabelP2P} from '../../graphql/mutations'
import {updateShipmentActivity, createShipmentLabelLambda, updateShipmentData, createLabelP2P} from '../../graphql/mutations'
// import AWSAutoComplete from '../AWSLocation/AddressAutoComplete.vue';
import AWSAutoComplete from '../AWSLocation/EsriAddressAutoComplete.vue';
// import AWSAddressCorrection from '../AWSLocation/AddressCorrection.vue';
import AWSAddressCorrection from '../AWSLocation/EsriAddressCorrection.vue';
import PdfLabelRenderer from '../ShipmentDashboard/PdfLabelRenderer.vue'
import LocationMap from '../AWSLocation/LocationMap.vue';
import ActivityProductTemplate from './ProductDashboard/ActivityProductTemplate.vue';

export default {
    props:['trackShipmentID', 'userData', 'jwtToken', 'cognitoUser'],
    components:{
        AlertUser,
        ShipmentLabel,
        LoadingCharts,
        AWSAutoComplete,
        AWSAddressCorrection,
        PdfLabelRenderer,
        LocationMap,
        LoadingData,
        ActivityProductTemplate
    },
    data(){
        return{
            showImage: {},
            loading: {},
            toggleReturnToSender: false,
            toggleReOpenShipment: false,
            shipmentData: null,
            toggleAlertBox: false, 
            alertMessage: null,
            labelData: null,
            loadingData: false,
            updateServiceAddressToggleValue: false,
            updatePickupAddressToggleValue: false,
            placeHolder: "Search for address",
            validateCustomAddress: false,
            geoCodeUrl: "",
            manifestIsDelivery: null,
            userCustomAddress: "",
            AdminUser: false,
            InternalAdmin: false,
            ManifestAdmin: false,
            CreateNewAccount: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            internalCommentInput: "",
            closeShipmentComment: "",
            rePickupComment: "",
            linkImageURL: '',
            indexImageURL: 0,
            showOverLay: false,
            toggleCloseOut: false,
            showPdfRenderer: false,
            activityUpdateValue: null,
            toggleMapView: false,
            toggleMapViewByIndex: [],
            toggleRePickupInitiate: false,
            toggleVoid: false,
            toggleClearFromManifest: false,
            voidComment: "",
            toggleManifestAdminBox: false,
            toggleReSameDayInitiate: false,
            selectedActivity: null,
            shipmentProducts: [],
            showActivityProductTemplate: false,
            showAddressActivityProduct: false,
            showReturnToSenderActivityProduct: false,
            updateWeightToggleValue: false,
            showWeightActivityProduct: false,
            excludeProductFromWeight: false,
            chargeSameDayToggleValue: false,
            showSameDayActivityProduct: false,
            excludeSameDayCharge: false,
            // statusID of the "chargeSameDay" activity in the Activities table.
            sameDayStatusID: 78
        }
    },
    computed:{
        isPickupPage(){
            return this.$route.name == "PickupDashboard"
        },
        isManifestDashboard(){
            return this.$route.name == "ManifestDashboard"
        },
        isSameDayService(){
            return (this.shipmentData?.service || "").toLowerCase() == "sameday"
        },
        shipmentServiceType(){
            if(this.shipmentData.service == "SSLRLOC"){
                return "Standard"
            }else if(this.shipmentData.service == "PSLRLOC"){
                return "Priority"
            }else if(this.shipmentData.service == "SSLRPICK"){
                return "Pickup"
            }else{
                return this.shipmentData.service
            }
        }
    },
    methods:{
        handleActivitySelected(activity) {
            this.selectedActivity = activity;
            // Clear products when activity changes - they'll be repopulated on apply
            this.shipmentProducts = [];
        },

        handleProductsLoaded(result) {
            // Automatically store loaded products so they're available for address updates
            if (result && Array.isArray(result.products)) {
                this.shipmentProducts = result.products;
            }
        },

        applyActivityProducts() {
            if (!this.selectedActivity || !this.shipmentProducts.length) {
                return;
            }

            this.handleProductTemplate({
                activityCode: this.selectedActivity.code,
                statusID: this.selectedActivity.statusID,
                activity: this.selectedActivity,
                products: this.shipmentProducts,
            });
        },

        toggleUpdateWeight() {
            this.updateWeightToggleValue = !this.updateWeightToggleValue;
            if (this.updateWeightToggleValue) {
                this.showWeightActivityProduct = true;
            }
        },

        triggerWeightUpdate() {
            // Trigger the ActivityProductTemplate's internal apply to get edited values
            const ref = this.$refs.weightActivityProduct;
            if (ref && ref.applyProductChanges) {
                ref.applyProductChanges();
            } else {
                // Fallback if ref not ready
                this.updateWeightActivity();
            }
        },

        handleWeightApply(result) {
            if (!result) {
                this.toggleAlertBox = true;
                this.alertMessage = "Please enter a valid weight in the product details.";
                return;
            }

            // Store the edited products then run weight update
            this.shipmentProducts = result.products || [];
            this.selectedActivity = result.activity;
            this.excludeProductFromWeight = result.excludeProduct || false;
            this.updateWeightActivity();
        },

        async updateWeightActivity() {
            // Get weight from the product quantity
            let weight = null;
            if (Array.isArray(this.shipmentProducts) && this.shipmentProducts.length > 0) {
                const productWithQuantity = this.shipmentProducts.find(p => parseFloat(p.quantity) > 0);
                if (productWithQuantity) {
                    weight = parseFloat(productWithQuantity.quantity);
                }
            }

            // Must have a valid weight regardless of exclude
            if (!weight || weight <= 0) {
                this.toggleAlertBox = true;
                this.alertMessage = "Please enter a valid weight in the product details.";
                return;
            }

            this.loadingData = true;
            const activityTimeISO = new Date().toISOString();

            // Build shipment payload — always include weight
            let shipmentPayload = { weight: weight };

            // Only include products if not excluded
            if (!this.excludeProductFromWeight && this.shipmentProducts.length > 0) {
                const productInput = this.shipmentProducts.map(product => {
                    const cleanProduct = { ...product };
                    delete cleanProduct.__typename;
                    delete cleanProduct._version;
                    delete cleanProduct._deleted;
                    delete cleanProduct._lastChangedAt;
                    cleanProduct.quantity = weight;
                    return cleanProduct;
                });
                shipmentPayload.product = productInput;
            }

            try {
                await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: this.selectedActivity?.code || "weightUpdate",
                            statusID: 77,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: `Weight updated to ${weight} lbs`,
                            shipment: JSON.stringify(shipmentPayload),
                        },
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                this.toggleAlertBox = true;
                this.alertMessage = "Weight updated successfully.";
            } catch (error) {
                console.error("Error updating weight:", error);
                this.toggleAlertBox = true;
                this.alertMessage = error?.errors?.[0]?.message || "Unable to update weight.";
            } finally {
                this.loadingData = false;
                this.updateWeightToggleValue = false;
                await this.GetShipmentData();
            }
        },

        toggleChargeSameDay() {
            this.chargeSameDayToggleValue = !this.chargeSameDayToggleValue;
            if (this.chargeSameDayToggleValue) {
                this.showSameDayActivityProduct = true;
            }
        },

        triggerSameDayCharge() {
            // Trigger the ActivityProductTemplate's internal apply to get edited values
            const ref = this.$refs.sameDayActivityProduct;
            if (ref && ref.applyProductChanges) {
                ref.applyProductChanges();
            } else {
                this.chargeSameDayActivity();
            }
        },

        handleSameDayApply(result) {
            if (!result) {
                this.toggleAlertBox = true;
                this.alertMessage = "Please enter the same day charge values.";
                return;
            }
            this.shipmentProducts = result.products || [];
            this.selectedActivity = result.activity;
            this.excludeSameDayCharge = result.excludeProduct || false;
            this.chargeSameDayActivity();
        },

        async chargeSameDayActivity() {
            // The same day charge products (miles, wait time, tolls) carry their own
            // quantities set in the ActivityProductTemplate. Require at least one value.
            const products = Array.isArray(this.shipmentProducts) ? this.shipmentProducts : [];
            const hasValue = products.some(p => parseFloat(p.quantity) > 0);

            if (!hasValue) {
                this.toggleAlertBox = true;
                this.alertMessage = "Enter at least one same day charge value (miles, wait time, or tolls).";
                return;
            }

            this.loadingData = true;
            const activityTimeISO = new Date().toISOString();

            let shipmentPayload = {};
            if (!this.excludeSameDayCharge && products.length > 0) {
                const productInput = products.map(product => {
                    const cleanProduct = { ...product };
                    delete cleanProduct.__typename;
                    delete cleanProduct._version;
                    delete cleanProduct._deleted;
                    delete cleanProduct._lastChangedAt;
                    return cleanProduct;
                });
                shipmentPayload.product = productInput;
            }

            try {
                await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: this.selectedActivity?.code || "chargeSameDay",
                            statusID: this.sameDayStatusID,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: "Same day charges added",
                            shipment: JSON.stringify(shipmentPayload),
                        },
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                this.toggleAlertBox = true;
                this.alertMessage = "Same day charges added successfully.";
            } catch (error) {
                console.error("Error adding same day charges:", error);
                this.toggleAlertBox = true;
                this.alertMessage = error?.errors?.[0]?.message || "Unable to add same day charges.";
            } finally {
                this.loadingData = false;
                this.chargeSameDayToggleValue = false;
                await this.GetShipmentData();
            }
        },

        async handleProductTemplate(result) {
            console.log("Selected activity:", result.activity);
            console.log("Updated products:", result.products);

            if (
                !result ||
                !result.activityCode ||
                result.statusID == null ||
                !Array.isArray(result.products)
            ) {
                this.toggleAlertBox = true;
                this.alertMessage =
                    "The activity or product information is incomplete.";
                return;
            }

            // Store products so they can be included with address updates
            this.shipmentProducts = result.products;

            await this.updateShipmentActivityProduct({
                activityCode: result.activityCode,
                statusID: result.statusID,
                products: result.products,
            });
        },
        async updateShipmentActivityProduct({
            activityCode,
            statusID,
            products,
        }) {
            if (!activityCode || statusID == null) {
                return;
            }

            this.loadingData = true;

            const activityTimeISO = new Date().toISOString();

            const userName = this.userData?.userName;

            const internalComments =
                statusID == 12 || statusID == 2012
                    ? `Admin Scan${userName ? ` - ${userName}` : ""}`
                    : "";

            /*
            * Remove GraphQL-only properties before sending the
            * Product objects into another mutation.
            */
            const productInput = (products || []).map(product => {
                const cleanProduct = {
                    ...product,
                };

                delete cleanProduct.__typename;
                delete cleanProduct._version;
                delete cleanProduct._deleted;
                delete cleanProduct._lastChangedAt;

                return cleanProduct;
            });

            try {
                const shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(
                                this.shipmentData.shipmentID
                            ),
                            Code: activityCode,
                            statusID,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: internalComments,

                            /*
                            * This name must match the Product array
                            * field in updateShipmentActivityInput.
                            */
                            shipment: JSON.stringify({
                                product: productInput,
                            }),
                        },
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                console.log(
                    "Shipment activity updated:",
                    shipmentActivity
                );

                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Updated.";
            } catch (error) {
                console.error(
                    "Unable to update shipment activity:",
                    error
                );

                this.toggleAlertBox = true;

                this.alertMessage =
                    error?.errors?.[0]?.message ||
                    "Unable to update shipment.";
            } finally {
                this.loadingData = false;
                this.toggleCloseOut = false;

                await this.GetShipmentData();
            }
        },
        openActivityMap(index){
            this.toggleMapViewByIndex = [];
            this.toggleMapView = false;
            this.toggleMapViewByIndex[index] = !this.toggleMapViewByIndex[index]
        },
        getMapShipmentData(items) {
            return {
                ...this.shipmentData,
                serviceAddress: {
                    ...this.shipmentData.serviceAddress,
                    address: {
                        ...this.shipmentData.serviceAddress.address,
                        latitude: items.latitude,
                        longitude: items.longitude
                    }
                }
            };
        },
        ShowLabelRender(){
            this.showPdfRenderer = !this.showPdfRenderer;
        },
        formatLocalTime(utcDate) {
            const date = new Date(utcDate);

            const formattedDate = date.toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                //second: 'numeric',
                hour12: true
            });

            return formattedDate;
        },
        showLoading(index) {
            this.loading[index] = true; // Updating loading state without `this.$set()`
        },
        // Function to handle when image has finished loading
        handleImageLoad(index) {
            this.loading[index] = false; // Updating loading state
        },
        shouldShowItem(items) {
            // Always return true if InternalAdmin or AdminUser is true
            if (this.InternalAdmin || this.AdminUser) {
                return true;
            }

            // Return false if customerVisible is explicitly false
            if (items.customerVisible === false) {
                return false;
            }

            // Default case
            return true;
        },
        async GeneratePresignedURL(indexImageURL){
            this.loadingData = true;
            const region = awsconfig.aws_project_region;
            const credentials = await Auth.currentCredentials();
            AWS.config.update({
                credentials: new AWS.Credentials({
                    accessKeyId: credentials.accessKeyId,
                    secretAccessKey: credentials.secretAccessKey,
                    sessionToken: credentials.sessionToken
                }),
                region: region
            });
            const kmsClient = new AWS.KMS();
            try {
                let expires = new Date();
                expires.setMinutes(expires.getMinutes() + 15);
                expires = expires.getTime().toString();

                const imagePath = this.shipmentData.activity[indexImageURL].imageURL.split('.com/')[1];

                const params = {
                    KeyId: process.env.VUE_APP_AWS_KMS_KEY_ALIAS,
                    Message: Buffer.from(imagePath + expires),
                    MacAlgorithm: 'HMAC_SHA_256'
                };

                const data = await kmsClient.generateMac(params).promise();
                const imageName = this.shipmentData.activity[indexImageURL].imageURL.substring(this.shipmentData.activity[indexImageURL].imageURL.lastIndexOf('/') + 1);
                let getFilesEndpoint = process.env.VUE_APP_AWS_GET_FILES_ENDPOINT
                const signedURL = `${getFilesEndpoint}/deliveryimage/${encodeURIComponent(imagePath)}/${expires}/${Buffer.from(data.Mac).toString('hex')}/${imageName}`;
                this.showOverLay = true;
                this.linkImageURL = signedURL
                return signedURL;
            } catch (error) {
                console.error('Error generating shipping label URL:', error);
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to access delivery image."
                throw new Error("Error generating shipping label URL");
            }finally{
                this.loadingData = false;
            }
        },
        async GetShipmentData(){
            try{
                let getShipment = await API.graphql({
                query:  `query getShipment{
                        getShipment(shipmentID: "${this.trackShipmentID}"){
                            owner
                            shipmentID
                            weight
                            currentKey
                            historyKey
                            inTransitKey
                            labelImage
                            accountNo
                            username
                            service
                            ref1
                            ref2
                            ref3
                            ref4
                            ref5
                            additionalRefs
                            signedLabelURL
                            additionalServices
                            deliveryInstructions
                            product{
                                serviceNetwork
                                productCode
                                additionalService
                            }
                            serviceAddress{
                            address{
                                companyName
                                address1
                                address2
                                city
                                state
                                zipCode
                                attention
                                phone
                                latitude
                                longitude
                                relevance
                                routeCode
                            }
                            }
                            deliveryPickup{
                            address{
                                companyName
                                address1
                                address2
                                city
                                state
                                zipCode
                                attention
                                phone
                                latitude
                                longitude
                                relevance
                                routeCode
                            }
                            }
                            deliveryPhone
                            deliveryEmail
                            nonDeliveryEmail
                            nonDeliveryPhone
                            externalTrackingNumber
                            activity{
                                internalComments
                                description
                                activityTime
                                imageKeyID
                                statusID
                                shippingEvent
                                imageURL
                                signedImageURL
                                customerVisible
                                latitude
                                longitude
                            }
                        }
                        }`,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(getShipment.data.getShipment == null){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting shipment"
                    setTimeout(() => {
                        this.closeShipmentInfo();
                    }, 1000);
                }else{
                    console.log(this.userData)
                    if((this.CustomerAdmin == true) && (this.userData?.accountNo != getShipment.data.getShipment.accountNo)){
                        this.toggleAlertBox = true;
                        this.alertMessage = "Unauthorized to access this shipment."
                        setTimeout(() => {
                            this.closeShipmentInfo();
                        }, 1000);
                    }else{
                        this.shipmentData = getShipment.data.getShipment;
                        console.log(this.shipmentData)
                        // On the ManifestDashboard, look up delivery/pickup from ManifestShipment for the geocode UI label
                        if(this.isManifestDashboard){
                            this.manifestIsDelivery = await this.getManifestIsDelivery();
                        }
                    }
                }
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting shipment"
                    setTimeout(() => {
                        this.closeShipmentInfo();
                    }, 1000);
                }
            }
        },
        async addInternalComment(){
            let date = new Date();
            this.loadingData = true;
            document.querySelector(".internal-comment-button").disabled = true;
            //Status ID 49 = Internal Comment
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            Code: "49",
                            Description: "Internal Comment",
                            statusID: "49",
                            ShipmentStage: "InternalComment",
                            ShipmentPoint: "InternalComment",
                            ShippingEvent: "InternalComment",
                            ActivityTime: date.toJSON(),
                            RecordedTime: date.toJSON(),
                            Comments: this.internalCommentInput,
                            InternalComments: this.internalCommentInput,
                            Notes: this.internalCommentInput,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            TripSheetId: 127,
                            ShipmentStatusId: 49,
                            ProcessedDate: date.toJSON(),
                            Latitude: "",
                            Longitude: "",
                            Altitude: ""
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Comment Added"
                console.log(shipmentActivity.data.updateShipmentActivity)
                this.internalCommentInput = "";
                this.GetShipmentData();
                this.loadingData = false;
                document.querySelector(".internal-comment-button").disabled = false;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to add comment"
                this.loadingData = false;
                document.querySelector(".internal-comment-button").disabled = false;
            }
        },
        async voidShipmentUpdateActivity(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            // Stamp the acting user on the void activity (mirrors the warehouse-scan pattern),
            // appended to any operator comment.
            const userName = this.userData?.userName;
            const internalComments = [this.voidComment, userName]
                .filter(Boolean)
                .join(" - ");
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "voided",
                            statusID: 4,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: internalComments
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Voided."
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to void shipment."
            }finally{
                this.loadingData = false;
                this.toggleVoid = false;
                this.GetShipmentData();
            }
        },
        async clearFromManifestUpdateActivity(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "clearFromManifest",
                            statusID: 2013,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: this.voidComment || ""
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Cleared From Manifest."
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to clear manifest shipment."
            }finally{
                this.loadingData = false;
                this.toggleClearFromManifest = false;
                this.GetShipmentData();
            }
        },
        async returnToSenderUpdateActivity(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            let address = this.shipmentData.deliveryPickup.address;
            let originalAddress = this.shipmentData.serviceAddress.address;

            // Build shipment payload with optional product data
            let shipmentPayload = {
                serviceAddress: {
                    address
                },
                originalServiceAddress: JSON.stringify({
                    originalAddress
                })
            };

            if (Array.isArray(this.shipmentProducts) && this.shipmentProducts.length > 0) {
                const productInput = this.shipmentProducts.map(product => {
                    const cleanProduct = { ...product };
                    delete cleanProduct.__typename;
                    delete cleanProduct._version;
                    delete cleanProduct._deleted;
                    delete cleanProduct._lastChangedAt;
                    return cleanProduct;
                });
                shipmentPayload.product = productInput;
            }

            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "returnstoSender",
                            statusID: 24,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: "",
                            shipment: JSON.stringify(shipmentPayload)
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Addresses Updated."
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to return shipment."
            }finally{
                setTimeout(() => {
                    this.loadingData = false;
                    this.toggleReturnToSender = false;
                    this.GetShipmentData();
                    this.ShowLabelRender();
                }, 5000);
            }
        },
        async reOpenShipmentProcess(){
            try {
                await this.reOpenShipment();
                this.activityUpdateValue = 12;
                await this.updateShipmentActivityStatus();
            } catch (error) {
                console.log(error);
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to reopen shipment."
            }
        },
        async reOpenShipment(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "reviewed",
                            statusID: 2007,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: "Shipment Reopened" + ` - ${this.userData.userName}`
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Reopened"
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to reopen shipment."
                throw error;
            }finally{
                setTimeout(() => {
                    this.loadingData = false;
                    this.toggleReOpenShipment = false;
                    this.GetShipmentData();
                }, 5000);
            }
        },
        toggleVoidShipment(){
            this.toggleVoid = !this.toggleVoid;
        },
        toggleClearFromManifestFunc(){
            this.toggleClearFromManifest = !this.toggleClearFromManifest;
        },
        toggleRePickupInitiateShipment(){
            this.toggleRePickupInitiate = !this.toggleRePickupInitiate;
        },
        toggleReInitiateSameDay(){
            this.toggleReSameDayInitiate = !this.toggleReSameDayInitiate;
        },
        async rePickupInitiateShipmentUpdateActivity(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "pickUpInitiated",
                            statusID: 9,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: this.rePickupComment || ""
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment pickup was successfully re-initiated."
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to re-initiate pickup."
            }finally{
                this.loadingData = false;
                this.toggleRePickupInitiate = false;
                this.GetShipmentData();
            }
        },
        async reSameDayInitiateShipmentUpdateActivity(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "sameDayInitiated",
                            statusID: 76,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: this.rePickupComment || ""
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment same day was successfully re-initiated."
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to re-initiate same day."
            }finally{
                this.loadingData = false;
                this.toggleReSameDayInitiate = false;
                this.GetShipmentData();
            }
        },
        toggleCloseOutShipment(){
            this.toggleCloseOut = !this.toggleCloseOut;
        },
        async closeShipmentUpdateActivity(){
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            // Stamp the acting user on the close-out activity (mirrors the warehouse-scan
            // pattern), appended to any operator comment.
            const userName = this.userData?.userName;
            const internalComments = [this.closeShipmentComment, userName]
                .filter(Boolean)
                .join(" - ");
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "SYSHIS",
                            statusID: 67,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: internalComments
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Closed."
                console.log(shipmentActivity.data.updateShipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to close shipment."
            }finally{
                this.loadingData = false;
                this.toggleCloseOut = false;
                this.GetShipmentData();
            }
        },
        async updateShipmentActivityStatus(){
            if(this.activityUpdateValue == null){
                return;
            }
            this.loadingData = true;
            let activityTime = new Date();
            let activityTimeISO = activityTime.toISOString();
            const internalComments = this.activityUpdateValue == 12 || this.activityUpdateValue == 2012
            ? `Admin Scan${this.userData.userName ? ` - ${this.userData.userName}` : ""}`
            : "";
                
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: this.shipmentData.shipmentID,
                            ShipmentId: parseInt(this.shipmentData.shipmentID),
                            Code: "",
                            statusID: this.activityUpdateValue,
                            ActivityTime: activityTimeISO,
                            RecordedTime: activityTimeISO,
                            InternalComments: internalComments
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Shipment Updated."
                console.log(shipmentActivity)
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to update shipment."
            }finally{
                this.loadingData = false;
                this.toggleCloseOut = false;
                this.GetShipmentData();
            }
        },
        async updateShipmentData(){
            let phoneValidated;
            let statusID;
            if((this.updatePickupAddressToggleValue == true) && (this.shipmentData.deliveryPickup.address.phone.length !== 0)){
                phoneValidated = this.cleanAndValidatePhoneNumber(this.shipmentData.deliveryPickup.address.phone);
            }else if((this.updateServiceAddressToggleValue == true) && (this.shipmentData.serviceAddress.address.phone !== 0)){
                phoneValidated = this.cleanAndValidatePhoneNumber(this.shipmentData.serviceAddress.address.phone);
            }else if((this.updatePickupAddressToggleValue == true) && (this.shipmentData.deliveryPickup.address.phone.length == 0)){
                phoneValidated = true;
            }else if((this.updateServiceAddressToggleValue == true) && (this.shipmentData.serviceAddress.address.phone.length == 0)){
                phoneValidated = true;
            }

            this.loadingData = true;

            if(this.updateServiceAddressToggleValue){
                statusID = 61
            }else if(this.updatePickupAddressToggle){
                statusID = 60
            }

            let input = {
                    shipmentId: this.shipmentData.shipmentID,
                    deliveryCompanyName: this.shipmentData.serviceAddress.address.companyName,
                    deliveryAttention: this.shipmentData.serviceAddress.address.attention,
                    deliveryRouteCode: this.shipmentData.serviceAddress.address.routeCode,
                    deliveryAddress1: this.shipmentData.serviceAddress.address.address1,
                    deliveryAddress2: this.shipmentData.serviceAddress.address.address2,
                    deliveryCity: this.shipmentData.serviceAddress.address.city,
                    deliveryState: this.shipmentData.serviceAddress.address.state,
                    deliveryZipCode: this.shipmentData.serviceAddress.address.zipCode,
                    deliveryPhone: this.shipmentData.serviceAddress.address.phone,
                    deliveryLatitude: this.shipmentData.serviceAddress.address.latitude,
                    deliveryLongitude: this.shipmentData.serviceAddress.address.longitude,
                    deliveryAddressRelevance: this.shipmentData.serviceAddress.address.relevance,
                    pickupCompanyName: this.shipmentData.deliveryPickup.address.companyName,
                    pickupAttention: this.shipmentData.deliveryPickup.address.attention,
                    pickupRouteCode: this.shipmentData.deliveryPickup.address.routeCode,
                    pickupAddress1: this.shipmentData.deliveryPickup.address.address1,
                    pickupAddress2: this.shipmentData.deliveryPickup.address.address2,
                    pickupCity: this.shipmentData.deliveryPickup.address.city,
                    pickupState: this.shipmentData.deliveryPickup.address.state,
                    pickupZipCode: this.shipmentData.deliveryPickup.address.zipCode,
                    pickupPhone: this.shipmentData.deliveryPickup.address.phone,
                    pickupLatitude: this.shipmentData.deliveryPickup.address.latitude,
                    pickupLongitude: this.shipmentData.deliveryPickup.address.longitude,
                    pickupAddressRelevance: this.shipmentData.deliveryPickup.address.relevance,
                    addShipmentProcessStatusID: statusID
                }

            // Include product data from the activity if available
            if (this.selectedActivity && Array.isArray(this.shipmentProducts) && this.shipmentProducts.length > 0) {
                const productInput = this.shipmentProducts.map(product => {
                    const cleanProduct = { ...product };
                    delete cleanProduct.__typename;
                    delete cleanProduct._version;
                    delete cleanProduct._deleted;
                    delete cleanProduct._lastChangedAt;
                    return cleanProduct;
                });
                input.product = productInput;
            }
            
            Object.keys(input).forEach(key => {
                if (input[key] === null) {
                    input[key] = ""
                }
            });

            if(phoneValidated == true){
            try{
                    await API.graphql({
                    query: updateShipmentData,
                    variables: {
                        input
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                    }).then((response)=>{
                        console.log(response)
                        this.GetShipmentData();
                        this.updateServiceAddressToggleValue = false
                        this.updatePickupAddressToggleValue = false
                        this.toggleAlertBox = true;
                        this.alertMessage = "Shipment has been updated."
                        this.loadingData = false;
                        //EMIT Trigger for Manifest Dashboard Refresh Map
                        this.$emit('refreshOpenManifest', true)
                    })
                }catch(e){
                    if(e.errors[0].message){
                        this.alertMessage = e.errors[0].message;
                    }else{
                        this.alertMessage = "Error updating shipment.";
                    }
                    this.toggleAlertBox = true;
                    this.loadingData = false;
                }
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Add a valid phone number."
                this.loadingData = false;
            }
        },
        /**
         * Parses a Google URL, Bing URL, or raw "lat,lng" string and returns { latitude, longitude }.
         * Priority order (most accurate first):
         *   1. Raw "lat, lng" paste (Google right-click coordinates)
         *   2. Google place/pin coordinates: !3d<lat>!4d<lng>
         *   3. Google query coordinates: ?q=<lat>,<lng>
         *   4. Google map center: @<lat>,<lng>
         *   5. Bing map center: cp=<lat>~<lng>
         * Note: shortened links (maps.app.goo.gl) do not contain coordinates and won't parse.
         */
        parseGeoCodeUrl(url){
            if(!url) return null;

            const trimmed = url.trim();

            // 1. Raw "lat,lng" paste (from Google right-click). Must be the whole value, not part of a URL.
            const rawMatch = trimmed.match(/^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)$/);
            if(rawMatch){
                return { latitude: rawMatch[1], longitude: rawMatch[2] };
            }

            // 2. Google Maps place/pin location: !3d<lat>!4d<lng> (the actual marker, most accurate)
            const googlePinMatch = trimmed.match(/!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/);
            if(googlePinMatch){
                return { latitude: googlePinMatch[1], longitude: googlePinMatch[2] };
            }

            // 3. Google Maps query: ?q=lat,lng or &q=lat,lng
            const qMatch = trimmed.match(/[?&]q=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
            if(qMatch){
                return { latitude: qMatch[1], longitude: qMatch[2] };
            }

            // 4. Google Maps map center: @lat,lng
            const googleMatch = trimmed.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
            if(googleMatch){
                return { latitude: googleMatch[1], longitude: googleMatch[2] };
            }

            // 5. Bing Maps: cp=lat~lng (the ~ may be URL-encoded as %7E)
            const bingMatch = trimmed.match(/cp=(-?\d+(?:\.\d+)?)(?:~|%7E)(-?\d+(?:\.\d+)?)/i);
            if(bingMatch){
                return { latitude: bingMatch[1], longitude: bingMatch[2] };
            }

            return null;
        },
        /**
         * Looks up the ManifestShipment record for this shipment to determine
         * whether it is a delivery or pickup stop. Returns true/false, or null if not found.
         */
        async getManifestIsDelivery(){
            try{
                const response = await API.graphql({
                    query: `query manifestShipmentID($shipmentID: String!) {
                        manifestShipmentID(shipmentID: $shipmentID) {
                            items {
                                shipmentID
                                isDelivery
                            }
                        }
                    }`,
                    variables: { shipmentID: this.shipmentData.shipmentID.toString() },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                const items = response?.data?.manifestShipmentID?.items || [];
                if(items.length > 0){
                    return items[0].isDelivery;
                }
                return null;
            }catch(e){
                console.error("Error fetching ManifestShipment isDelivery:", e);
                return null;
            }
        },
        async updateShipmentDataGeoCode(){
            const coords = this.parseGeoCodeUrl(this.geoCodeUrl);
            if(!coords){
                this.toggleAlertBox = true;
                this.alertMessage = "Could not read coordinates from that URL. Paste a valid Google or Bing Maps URL.";
                return;
            }

            console.log(coords)

            this.loadingData = true;

            const shipmentLatitude = coords.latitude;
            const shipmentLongitude = coords.longitude;
            const shipmentRelevance = 1;

            // Determine delivery vs pickup from the ManifestShipment table for this shipment
            const isDelivery = await this.getManifestIsDelivery();
            if(isDelivery === null){
                this.toggleAlertBox = true;
                this.alertMessage = "Could not find this shipment in the manifest. GeoCode not updated.";
                this.loadingData = false;
                return;
            }

            let input = {
                shipmentId: this.shipmentData.shipmentID,
                deliveryCompanyName: this.shipmentData.serviceAddress.address.companyName,
                deliveryAttention: this.shipmentData.serviceAddress.address.attention,
                deliveryRouteCode: this.shipmentData.serviceAddress.address.routeCode,
                deliveryAddress1: this.shipmentData.serviceAddress.address.address1,
                deliveryAddress2: this.shipmentData.serviceAddress.address.address2,
                deliveryCity: this.shipmentData.serviceAddress.address.city,
                deliveryState: this.shipmentData.serviceAddress.address.state,
                deliveryZipCode: this.shipmentData.serviceAddress.address.zipCode,
                deliveryPhone: this.shipmentData.serviceAddress.address.phone,
                deliveryLatitude: this.shipmentData.serviceAddress.address.latitude,
                deliveryLongitude: this.shipmentData.serviceAddress.address.longitude,
                deliveryAddressRelevance: this.shipmentData.serviceAddress.address.relevance,
                pickupCompanyName: this.shipmentData.deliveryPickup.address.companyName,
                pickupAttention: this.shipmentData.deliveryPickup.address.attention,
                pickupRouteCode: this.shipmentData.deliveryPickup.address.routeCode,
                pickupAddress1: this.shipmentData.deliveryPickup.address.address1,
                pickupAddress2: this.shipmentData.deliveryPickup.address.address2,
                pickupCity: this.shipmentData.deliveryPickup.address.city,
                pickupState: this.shipmentData.deliveryPickup.address.state,
                pickupZipCode: this.shipmentData.deliveryPickup.address.zipCode,
                pickupPhone: this.shipmentData.deliveryPickup.address.phone,
                pickupLatitude: this.shipmentData.deliveryPickup.address.latitude,
                pickupLongitude: this.shipmentData.deliveryPickup.address.longitude,
                pickupAddressRelevance: this.shipmentData.deliveryPickup.address.relevance,
                addShipmentProcessStatusID: 0
            };

            // ManifestShipment isDelivery drives which address geocode is updated.
            // isDelivery true  -> update serviceAddress (delivery) geocode, status 64
            // isDelivery false -> update deliveryPickup (pickup) geocode, status 63
            if(isDelivery){
                input.deliveryLatitude = shipmentLatitude;
                input.deliveryLongitude = shipmentLongitude;
                input.deliveryAddressRelevance = shipmentRelevance;
                input.addShipmentProcessStatusID = 64;
            }else{
                input.pickupLatitude = shipmentLatitude;
                input.pickupLongitude = shipmentLongitude;
                input.pickupAddressRelevance = shipmentRelevance;
                input.addShipmentProcessStatusID = 63;
            }

            Object.keys(input).forEach(key => {
                if (input[key] === null) {
                    input[key] = ""
                }
            });

            try{
                await API.graphql({
                    query: updateShipmentData,
                    variables: { input },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                }).then((response)=>{
                    console.log(response)
                    this.geoCodeUrl = "";
                    this.GetShipmentData();
                    this.toggleAlertBox = true;
                    this.alertMessage = "Shipment GeoCode has been updated."
                    this.loadingData = false;
                    this.$emit('refreshOpenManifest', true)
                })
            }catch(e){
                if(e.errors && e.errors[0] && e.errors[0].message){
                    this.alertMessage = e.errors[0].message;
                }else{
                    this.alertMessage = "Error updating shipment.";
                }
                this.toggleAlertBox = true;
                this.loadingData = false;
            }
        },
        // async PrintLabel(){
        //     this.loadingData = true;
            
        //     if(!this.shipmentData.signedLabelURL){
        //         this.toggleAlertBox = true;
        //         this.alertMessage = "Shipment does not have a label."
        //         return;
        //     }
    
        //     try{
        //         let shipmentLabels = await API.graphql({
        //         query:  getMergedLabelsLREX,
        //         variables:{ input:{ pdfUrls: [this.shipmentData.signedLabelURL] } },
        //         authMode: "AMAZON_COGNITO_USER_POOLS",
        //         })
        //         this.labelData = "data:application/pdf;base64, " + shipmentLabels.data.getMergedLabelsLREX.mergedPDF;
        //     }catch(e){
        //         console.log(e)
        //         if(e){
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Error getting shipment label."
        //         }
        //     }finally{
        //         this.loadingData = false;
        //     }
        //     // if(this.shipmentData.product[0].serviceNetwork.includes('P2P')){
        //     //     await this.getParcelImageP2P();
        //     //     return;
        //     // }

        //     // let suppressMessageBool = false;
        //     // if(this.AdminUser || this.InternalAdmin){
        //     //     suppressMessageBool = true;
        //     // }

        //     // this.loadingData = true;
        //     // const renderRequest = {
        //     //         data: {
        //     //             user: this.userData.userName,
        //     //             jwtToken: this.jwtToken,
        //     //             idArray: [this.shipmentData.shipmentID],
        //     //             suppressMessage: suppressMessageBool
        //     //         },
        //     //         template: {
        //     //             name: "LREXTemplateGraphQLv2",
        //     //             engine: "handlebars",
        //     //             recipe: "chrome-pdf"
        //     //         }
        //     //     }
        //     // try{
        //     //     let shipmentLabels = await API.graphql({
        //     //     query:  createShipmentLabelLambda,
        //     //     variables:{ input:{renderRequest} },
        //     //     authMode: "AMAZON_COGNITO_USER_POOLS",
        //     //     })
        //     //     this.labelData = "data:application/pdf;base64, " + shipmentLabels.data.createShipmentLabelLambda.labelImage.slice(1, -1);
        //     //     const element = document.getElementById('inner-overflow-container');
        //     //     element.scrollTop = element.scrollHeight;
        //     // }catch(e){
        //     //     console.log(e)
        //     //     if(e){
        //     //         this.loadingData = false;
        //     //         this.toggleAlertBox = true;
        //     //         this.alertMessage = "Error printing label"
        //     //     }
        //     // }finally{
        //     //     this.loadingData = false;
        //     // }
        // },
        async PrintPickupLabel(){
            this.loadingData = true;
            const renderRequest = {
                    data: {
                        user: this.userData.userName,
                        jwtToken: this.jwtToken,
                        idArray: [this.shipmentData.shipmentID]
                    },
                    template: {
                        name: "LREXLabelGraphQLPickupTemplate",
                        engine: "handlebars",
                        recipe: "chrome-pdf"
                    }
                }
            try{
                let shipmentLabels = await API.graphql({
                query:  createShipmentLabelLambda,
                variables:{ input:{renderRequest} },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.labelData = "data:application/pdf;base64, " + shipmentLabels.data.createShipmentLabelLambda.labelImage.slice(1, -1);
                const element = document.getElementById('inner-overflow-container');
                element.scrollTop = element.scrollHeight;
            }catch(e){
                console.log(e)
                if(e){
                    this.loadingData = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error printing label"
                }
            }finally{
                this.loadingData = false;
            }
        },
        async getParcelImageP2P(){
            this.loadingData = true;
            this.p2pLabelArray = [];
            try {
                const response = await API.graphql({
                    query: createLabelP2P,
                    variables: {
                        input: {
                            UniqueParcelID: this.shipmentData.shipmentID,
                        },
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                if (response.data.createLabelP2P.status == "error") {
                    this.toggleAlertBox = true;
                    this.alertMessage = JSON.stringify({ "error": response.data.createLabelP2P.errors });
                } else {
                    if (response.data.createLabelP2P.Label) {
                        const returnLabel = response.data.createLabelP2P.Label;
                        this.labelData = "data:application/pdf;base64, " + returnLabel;
                        const element = document.getElementById('inner-overflow-container');
                        element.scrollTop = element.scrollHeight;
                    } else {
                        this.toggleAlertBox = true;
                        this.alertMessage = JSON.stringify({ "error": ["Error printing P2P Label."] });
                    }
                }
            } catch (e) {
                console.log(e);
                this.alertMessage = "Error with creating label.";
                this.toggleAlertBox = true;
                this.loadingData = false;
            }

            this.loadingData = false;
        },
        async printContent() {
            var divContents = document.getElementById("printable-content").innerHTML;

            for (let index = 0; index < this.shipmentData.activity.length; index++) {
                const element = this.shipmentData.activity[index];

                if (element.signedImageURL) {
                    const imgHTML = `<div class="image-container">
                        <img 
                        class="proof-delivery-image" 
                        src="${element.signedImageURL}" 
                        alt="Delivery Image" 
                        />
                    </div>`;
                    divContents += imgHTML;
                }
            }
            var a = window.open('LREX', 'LREX', 'height=1000, width=1000');
            a.document.write('<html>');
            a.document.write(`
                <head>
                    <title>Package Details</title>
                    <style>
                            @import url("https://fonts.googleapis.com/css2?family=Work+Sans&display=swap");
                            .st0{
                                fill: none;
                                stroke: #000000;
                                stroke-width: 8;
                                stroke-miterlimit: 10;
                            }

                            .st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}

                            .cls-1-alt{
                                fill: none;
                                stroke: #000;
                                stroke-miterlimit: 10;
                                stroke-width: 8px;
                            }

                            .main-button-blue-white{
                                display: none;
                            }

                            .image-container {
                                width: 40%;
                                max-width: 400px;
                                overflow: hidden;
                                display: flex;
                                justify-content: center;
                            }

                            .cls-1 {
                                fill: none;
                                stroke: #000;
                                stroke-miterlimit: 10;
                                stroke-width: 8px;
                            }

                            .cls-2 {
                                fill: none;
                                stroke: #000;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 12px;
                            }

                            .cls-2-alt{
                                stroke: #000;
                                fill: none;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 11px;
                            }

                        .proof-delivery-image {
                            max-width: 100%;   /* Ensures the image fits within its parent */
                            height: auto;      /* Maintains aspect ratio */
                            object-fit: contain; /* Keeps the whole image visible */
                        }

                        .proof-delivery-image {
                            width: 100%; 
                            height: 100%; 
                            border: none; 
                            display: block; 
                            margin-bottom: 20px;
                            border-radius: 25px;
                        }

                        .main-container-shipmentinfo{
                            font-family: 'Work Sans', sans-serif;
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            right: 0;
                            top: 0;
                            margin: 0;
                            padding: 0;
                            z-index: 10;
                        }

                        @keyframes shipment-details-animate {
                            from{
                                margin-top: -2%;
                            }
                            to{
                                margin-top: 2.5%;
                            }
                        }

                        .inner-container{
                            font-family: 'Work Sans', sans-serif;
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            text-align: left;
                            flex-direction: column;
                        }

                        .confirm-container-main{
                            font-family: 'Work Sans', sans-serif;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            width: fit-content;
                            overflow-x: auto;
                            animation: shipment-details-animate 1s ease;
                            margin-top: 2.5%;
                            background-color: #fff;
                            border-radius: 25px;
                        }

                        .confirm-header-container{
                            font-family: 'Work Sans', sans-serif;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            padding: 15px 15px 0 15px;
                            justify-content: space-between;
                        }

                        .confirm-header-container img{
                            width: 40px;
                            margin-right: 15px;
                        }

                        .legend-header-container{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }

                        .map-legend-container{
                            display: flex;
                            flex-direction: column;
                            width: fit-content;
                            padding: 5px;
                            border-radius: 25px;
                            background-color: #f5f5f5;
                            margin-bottom: 5px;
                        }

                        .map-legend{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                        }

                        .map-legend p{
                            margin-left: 5px;
                        }

                        .weight-container{
                            background-color: #fff;
                            margin: 0px 5% 2% 5%;
                            padding: 10px;
                            border-radius: 25px;
                            box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
                        }

                        .weight-container label{
                            margin-right: 5px;
                        }

                        .confirmContainerInner{
                            display: flex;
                            flex-direction: row;
                            justify-content: space-evenly;
                            text-align: left;
                            padding: 10px;
                        }

                        .confirmContainerInner1{
                            background-color: #f5f5f5;
                            margin: 5px;
                            padding: 10px;
                            border-radius: 25px;
                            flex-basis: 25%;
                            box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
                        }

                        .confirmContainerInner1 h2{
                            margin: 0;
                            text-align: left;
                            white-space: nowrap;
                        }

                        .notifications{
                            background-color: #f5f5f5;
                        }

                        .confirm-svg{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            background-color: #e4e4e4;
                            border-radius: 999px;
                            padding: 5px;
                            width: fit-content;
                        }

                        .confirm-svg svg{
                            width: 35px;
                            height: 35px;
                            padding-right: 5px;
                        }

                        .confirm-svg h2{
                            margin: 0;
                        }

                        .confirm-container-address{
                            display: flex;
                            flex-direction: row;
                            width: 100%;
                            flex-wrap: wrap;
                        }

                        .package-details-header{
                            background-color: #32ccfe;
                            color: #fff;
                            padding: 10px;
                            border-radius: 50px;
                            width: fit-content;
                            margin: 0;
                        }

                        .confirmContainerInner2{
                            background-color: #fff;
                            margin: 5px;
                            padding: 10px;
                            border-radius: 25px;
                            flex-basis: 25%;
                            box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
                        }

                        .confirmContainer{
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            align-items: center;
                        }

                        .confirmContainerInner label{
                            background-color: transparent;
                            border: none;
                            padding: 0px;
                            margin-right: 10px;
                            font-weight: bold;
                            white-space: nowrap;
                        }

                        .confirmLabelContainer{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;
                            height: auto;
                        }

                        .confirmLabelContainer p{
                            margin-top: 5px;
                            margin-bottom: 5px;
                        }

                        .confirmLabelContainer2{
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            width: 100%;
                            padding-bottom: 5px;
                        }

                        .confirmContainerInner2 h2{
                            text-align: left;
                            margin-top: 0;
                            margin-bottom: 0;
                        }

                        .notificationArray p{
                            display: flex;
                            flex-direction: column;
                            margin: 2px;
                        }

                        .close-shipment-info{
                            background-color: #32ccfe;
                            color: #fff;
                            border: none;
                            border-radius: 5px;
                            padding: 5px;
                            width: fit-content;
                            margin-right: 5%;
                            margin-top: 5px;
                            transition-duration: .5s;
                            cursor: pointer;
                        }

                        .close-shipment-info:hover{
                            transition-duration: .5s;
                            background-color: #2aa7d1;
                        }

                        .close-shipment-info-container{
                            display: none;
                        }

                        .print-button{
                            display: none;
                        }
                    
                    @media print {
                            .st0{
                                fill: none;
                                stroke: #000000;
                                stroke-width: 8;
                                stroke-miterlimit: 10;
                            }

                            .st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}

                            .cls-1-alt{
                                fill: none;
                                stroke: #000;
                                stroke-miterlimit: 10;
                                stroke-width: 8px;
                            }

                            .cls-1 {
                                fill: none;
                                stroke: #000;
                                stroke-miterlimit: 10;
                                stroke-width: 8px;
                            }

                            .cls-2 {
                                fill: none;
                                stroke: #000;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 12px;
                            }

                            .cls-2-alt{
                                stroke: #000;
                                fill: none;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 11px;
                            }

                        .main-container-shipmentinfo{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            right: 0;
                            top: 0;
                            margin: 0;
                            padding: 0;
                            z-index: 10;
                        }

                        .inner-container{
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            text-align: left;
                            flex-direction: column;
                        }

                        .confirm-container-main{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            width: fit-content;
                            overflow-x: auto;
                            margin-top: 2.5%;
                        }

                        .confirm-header-container{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            padding: 15px 15px 0 15px;
                            justify-content: space-between;
                        }

                        .confirm-header-container img{
                            width: 40px;
                            margin-right: 15px;
                        }

                        .legend-header-container{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }

                        .map-legend-container{
                            display: flex;
                            flex-direction: column;
                            width: fit-content;
                            padding: 5px;
                            border-radius: 25px;
                            background-color: #f5f5f5;
                            margin-bottom: 5px;
                        }

                        .map-legend{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                        }

                        .map-legend p{
                            margin-left: 5px;
                        }

                        .weight-container{
                            background-color: #fff;
                            margin: 0px 5% 2% 5%;
                            padding: 10px;
                            border-radius: 25px;
                            box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
                        }

                        .weight-container label{
                            margin-right: 5px;
                        }

                        .confirmContainerInner{
                            display: flex;
                            flex-direction: row;
                            justify-content: space-evenly;
                            text-align: left;
                            padding: 10px;
                        }

                        .confirmContainerInner1{
                            background-color: #f5f5f5;
                            margin: 5px;
                            padding: 10px;
                            border-radius: 25px;
                            flex-basis: 25%;
                            box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
                        }

                        .confirmContainerInner1 h2{
                            margin: 0;
                            text-align: left;
                            white-space: nowrap;
                        }

                        .notifications{
                            background-color: #f5f5f5;
                        }

                        .confirm-svg{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            background-color: #e4e4e4;
                            border-radius: 999px;
                            padding: 5px;
                            width: fit-content;
                        }

                        .confirm-svg svg{
                            width: 35px;
                            height: 35px;
                            padding-right: 5px;
                        }

                        .confirm-svg h2{
                            margin: 0;
                        }

                        .confirm-container-address{
                            display: flex;
                            flex-direction: row;
                            width: 100%;
                            flex-wrap: wrap;
                        }

                        .package-details-header{
                            background-color: #32ccfe;
                            color: #000;
                            padding: 10px;
                            border-radius: 50px;
                            width: fit-content;
                            margin: 0;
                        }

                        .confirmContainerInner2{
                            background-color: #fff;
                            margin: 5px;
                            padding: 10px;
                            border-radius: 25px;
                            flex-basis: 25%;
                            box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
                        }

                        .confirmContainer{
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            align-items: center;
                        }

                        .confirmContainerInner label{
                            background-color: transparent;
                            border: none;
                            padding: 0px;
                            margin-right: 10px;
                            font-weight: bold;
                            white-space: nowrap;
                        }

                        .confirmLabelContainer{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;
                            height: auto;
                        }

                        .confirmLabelContainer p{
                            margin-top: 5px;
                            margin-bottom: 5px;
                        }

                        .confirmLabelContainer2{
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            width: 100%;
                            padding-bottom: 5px;
                        }

                        .confirmContainerInner2 h2{
                            text-align: left;
                            margin-top: 0;
                            margin-bottom: 0;
                        }

                        .notificationArray p{
                            display: flex;
                            flex-direction: column;
                            margin: 2px;
                        }

                        .close-shipment-info{
                            background-color: #32ccfe;
                            color: #fff;
                            border: none;
                            border-radius: 5px;
                            padding: 5px;
                            width: fit-content;
                            margin-right: 5%;
                            margin-top: 5px;
                            transition-duration: .5s;
                            cursor: pointer;
                        }

                        .close-shipment-info:hover{
                            transition-duration: .5s;
                            background-color: #2aa7d1;
                        }

                        .close-shipment-info-container{
                            display: none;
                        }

                        .print-button{
                            display: none;
                        }

                        .inner-history-container p{
                            margin: 0;
                        }

                        .inner-history-container{
                            border: 1px solid #b3b3b3;
                            border-radius: 15px;
                            padding: 15px;
                            margin: 15px;
                            margin-left: 12.5%;
                            width: 50%;
                        }

                        .history-container{
                            position: relative;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                        }
                    }
                    </style>
                </head>
            `);
            a.document.write('<body>');
            a.document.write(divContents);
            a.document.write('</body></html>');
            this.showOverLay = false;
            setTimeout(function () {
                a.document.close();
                a.focus();
                a.print();
                a.close(); 
            }, 2000);
        },
        cleanAndValidatePhoneNumber(inputPhoneNumber) {
            // Remove all non-digit characters from the input phone number
            const cleanedPhoneNumber = inputPhoneNumber.replace(/\D/g, '');

            // Check if the cleaned phone number is exactly 10 digits
            if(cleanedPhoneNumber.length == 0){
                return true;
            }else if(cleanedPhoneNumber.length !== 10) {
                return false; // Invalid phone number
            }else{
                if(this.updatePickupAddressToggleValue == true){
                    this.shipmentData.deliveryPickup.address.phone = cleanedPhoneNumber;
                    return true;
                }

                if(this.updateServiceAddressToggleValue == true){
                    this.shipmentData.serviceAddress.address.phone = cleanedPhoneNumber;
                    return true;
                }
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        closeShipmentInfo(){
            this.$emit('closeShipmentInfo', false)
        },
        updateServiceAddressToggle(){
            this.updateServiceAddressToggleValue = true;
            this.updatePickupAddressToggleValue = false;
        },
        updatePickupAddressToggle(){
            this.updatePickupAddressToggleValue = true;
            this.updateServiceAddressToggleValue = false;
        },
        GetSelectedAddressData(selectedAddress){
            if(this.updatePickupAddressToggleValue){
                this.shipmentData.deliveryPickup.address.latitude = selectedAddress.latitude.toString();
                this.shipmentData.deliveryPickup.address.longitude = selectedAddress.longitude.toString();
                this.shipmentData.deliveryPickup.address.address1 = selectedAddress.address1;
                this.shipmentData.deliveryPickup.address.address2 = selectedAddress.address2;
                this.shipmentData.deliveryPickup.address.zipCode = selectedAddress.zipCode;
                this.shipmentData.deliveryPickup.address.city = selectedAddress.city;
                this.shipmentData.deliveryPickup.address.state = selectedAddress.state;
                this.shipmentData.deliveryPickup.address.relevance = selectedAddress.relevance.toString();
            }

            if(this.updateServiceAddressToggleValue){
                this.shipmentData.serviceAddress.address.latitude = selectedAddress.latitude.toString();
                this.shipmentData.serviceAddress.address.longitude = selectedAddress.longitude.toString();
                this.shipmentData.serviceAddress.address.address1 = selectedAddress.address1;
                this.shipmentData.serviceAddress.address.address2 = selectedAddress.address2;
                this.shipmentData.serviceAddress.address.zipCode = selectedAddress.zipCode;
                this.shipmentData.serviceAddress.address.city = selectedAddress.city;
                this.shipmentData.serviceAddress.address.state = selectedAddress.state;
                this.shipmentData.serviceAddress.address.relevance = selectedAddress.relevance.toString();
            }
        },
        customAddressToggle(toggleCustom){
            this.toggleAlertBox = toggleCustom;
            this.alertMessage = "Using custom addresses may incur additional costs.";

            document.getElementById('address1').disabled = false;
            document.getElementById('city').disabled = false;
            document.getElementById('state').disabled = false;
            document.getElementById('zipcode').disabled = false;
            this.validateCustomAddress = true;
        },
        useEnteredAddress(event){
            if(event.callInsertAddressBook == true){
                this.updateShipmentData();
            }
        },
        setCustomAddress(event){
            if(this.updatePickupAddressToggleValue){
                this.shipmentData.deliveryPickup.address.latitude = event.shipmentAddressData.latitude;
                this.shipmentData.deliveryPickup.address.longitude = event.shipmentAddressData.longitude;
                this.shipmentData.deliveryPickup.address.address1 = event.shipmentAddressData.Address1;
                this.shipmentData.deliveryPickup.address.address2 = event.shipmentAddressData.Address2;
                this.shipmentData.deliveryPickup.address.zipCode = event.shipmentAddressData.ZipCode;
                this.shipmentData.deliveryPickup.address.city = event.shipmentAddressData.City;
                this.shipmentData.deliveryPickup.address.state = event.shipmentAddressData.State;
                this.shipmentData.deliveryPickup.address.relevance = event.shipmentAddressData.relevance;
            }

            if(this.updateServiceAddressToggleValue){
                this.shipmentData.serviceAddress.address.latitude = event.shipmentAddressData.latitude;
                this.shipmentData.serviceAddress.address.longitude = event.shipmentAddressData.longitude;
                this.shipmentData.serviceAddress.address.address1 = event.shipmentAddressData.Address1;
                this.shipmentData.serviceAddress.address.address2 = event.shipmentAddressData.Address2;
                this.shipmentData.serviceAddress.address.zipCode = event.shipmentAddressData.ZipCode;
                this.shipmentData.serviceAddress.address.city = event.shipmentAddressData.City;
                this.shipmentData.serviceAddress.address.state = event.shipmentAddressData.State;
                this.shipmentData.serviceAddress.address.relevance = event.shipmentAddressData.relevance;
            }

            if(event.callInsertAddressBook == true){
                this.updateShipmentData();
                this.validateCustomAddress = false;
            }
        },
        useCorrectedAddress(event){
            if(this.updatePickupAddressToggleValue){
                this.shipmentData.deliveryPickup.address.latitude = event.shipmentDataValue.latitude;
                this.shipmentData.deliveryPickup.address.longitude = event.shipmentDataValue.longitude;
                this.shipmentData.deliveryPickup.address.address1 = event.shipmentDataValue.Address1;
                this.shipmentData.deliveryPickup.address.address2 = event.shipmentDataValue.Address2;
                this.shipmentData.deliveryPickup.address.zipCode = event.shipmentDataValue.ZipCode;
                this.shipmentData.deliveryPickup.address.city = event.shipmentDataValue.City;
                this.shipmentData.deliveryPickup.address.state = event.shipmentDataValue.State;
                this.shipmentData.deliveryPickup.address.relevance = event.shipmentDataValue.relevance;
            }

            if(this.updateServiceAddressToggleValue){
                this.shipmentData.serviceAddress.address.latitude = event.shipmentDataValue.latitude;
                this.shipmentData.serviceAddress.address.longitude = event.shipmentDataValue.longitude;
                this.shipmentData.serviceAddress.address.address1 = event.shipmentDataValue.Address1;
                this.shipmentData.serviceAddress.address.address2 = event.shipmentDataValue.Address2;
                this.shipmentData.serviceAddress.address.zipCode = event.shipmentDataValue.ZipCode;
                this.shipmentData.serviceAddress.address.city = event.shipmentDataValue.City;
                this.shipmentData.serviceAddress.address.state = event.shipmentDataValue.State;
                this.shipmentData.serviceAddress.address.relevance = event.shipmentDataValue.relevance;
            }
            
            if(event.callInsertAddressBook == true){
                this.updateShipmentData();
                this.validateCustomAddress = false;
            }
        },
        checkAddressCorrection(){
            if(this.updatePickupAddressToggleValue){
                this.userCustomAddress = this.shipmentData.deliveryPickup.address.address1 + " " + this.shipmentData.deliveryPickup.address.city + " " + this.shipmentData.deliveryPickup.address.state + " " + this.shipmentData.deliveryPickup.address.zipCode;
            }

            if(this.updateServiceAddressToggleValue){
                this.userCustomAddress = this.shipmentData.serviceAddress.address.address1 + " " + this.shipmentData.serviceAddress.address.city + " " + this.shipmentData.serviceAddress.address.state + " " + this.shipmentData.serviceAddress.address.zipCode;
            }
            //AddressCorrection Child Component is triggered when customAddress changes values
        },
        cancelAddressUpdate(){
            this.GetShipmentData();
            this.updateServiceAddressToggleValue = false
            this.updatePickupAddressToggleValue = false
            this.validateCustomAddress = false
        }
    },
    mounted(){
        this.GetShipmentData();
        if(this.cognitoUser.signInUserSession.idToken.payload['cognito:groups']){
            this.cognitoUser.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'ManifestAdmin'){
                        this.ManifestAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }
                })
        }

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
</script>

<style scoped>
/* SVG Styles */

    .st0{
        fill: none;
        stroke: #000000;
        stroke-width: 8;
        stroke-miterlimit: 10;
    }

    .st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}


    .cls-1-alt{
        fill: none;
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 8px;
    }

    .cls-1 {
        fill: none;
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 8px;
    }

    .cls-2 {
        fill: none;
        stroke: #000;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 12px;
    }

    .cls-2-alt{
        stroke: #000;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 11px;
    }

.main-container-shipmentinfo{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0;
    padding: 0;
    z-index: 10;
}

@keyframes shipment-details-animate {
    from{
        margin-top: -2%;
    }
    to{
        margin-top: 2.5%;
    }
}

.inner-container{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    flex-direction: column;
}

.confirm-container-main{
    display: flex;
    flex-direction: column;
    width: fit-content;
    max-height: 90vh;
    min-width: 300px;
    overflow: hidden;
    animation: shipment-details-animate 1s ease;
    margin-top: 2.5%;
    box-shadow: rgba(0, 0, 0, 0.164) 0px 1px 10px;
    background-color: #fff;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
    resize: both;
}

.confirm-header-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 15px 0 15px;
    justify-content: space-between;
}

.confirm-header-container img{
    width: 40px;
    margin-right: 15px;
}

.legend-header-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.map-legend-container{
    display: flex;
    flex-direction: column;
    width: fit-content;
    padding: 5px;
    border-radius: 25px;
    background-color: #f5f5f5;
    margin-bottom: 5px;
}

.map-legend{
    display: flex;
    flex-direction: row;
    align-items: center;
}

.map-legend p{
    margin-left: 5px;
}

.weight-container{
    background-color: #fff;
    margin: 0px 5% 2% 5%;
    padding: 10px;
    border-radius: 25px;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
}

.weight-container label{
    margin-right: 5px;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    text-align: left;
    padding: 10px;
}

.inner-overflow-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 10px;
    margin: 5px;
    border-top: 1px #d5d5d5 solid;
    border-bottom: 1px #d5d5d5 solid;
    /* border-radius: 25px; */
}

.activity-update select{
    margin-top: 0;
    margin-right: 5px;
}

.activity-update{
    display: flex;
    flex-direction: row;
    align-items: center;
}

.confirmContainerInner1{
    background-color: #f5f5f5;
    margin: 5px;
    padding: 10px;
    border-radius: 25px;
    flex-basis: 25%;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
}

.confirmContainerInner1 h2{
    margin: 0;
    text-align: left;
    white-space: nowrap;
}

.auto-complete-container{
    margin-bottom: 5px !important;
    width: 90%;
    display: block;
    margin: auto;
}

input, select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}

.notifications{
    background-color: #f5f5f5;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.confirm-container-address{
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
}

.package-details-header{
    background-color: #32ccfe;
    color: #fff;
    padding: 10px;
    border-radius: 50px;
    width: fit-content;
    margin: 0;
}

.confirmContainerInner2{
    background-color: #fff;
    margin: 5px;
    padding: 10px;
    border-radius: 25px;
    flex-basis: 25%;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
}

.confirmContainer{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.confirmContainerInner label{
    background-color: transparent;
    border: none;
    padding: 0px;
    margin-right: 10px;
    font-weight: bold;
    white-space: nowrap;
}

.confirmLabelContainer{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
}

.confirmLabelContainer p{
    margin-top: 5px;
    margin-bottom: 5px;
}

.confirmLabelContainer2{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-bottom: 5px;
}

.confirmContainerInner2 h2{
    text-align: left;
    margin-top: 0;
    margin-bottom: 0;
}

.add-comment-container{
    display: flex;
    justify-content: flex-start;
    /* align-items: center; */
    flex-direction: row;
}

.add-comment-container textarea{
    border: 1px solid #e2e2e2;
    border-right: none;
    padding: 5px;
    border-radius: 10px 0px 0px 10px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 5px 15px;
    outline: none;
    margin-top: 0;
}

.add-comment-container button{
    cursor: pointer;
    border: 1px solid #e2e2e2;
    background-color: #32ccfe;
    color: #fff;
    padding: 5px;
    border-radius: 0px 10px 10px 0px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 5px 15px;
    transition-duration: .5s;
}

.add-comment-container button:hover{
    background-color: #2baeda;
    transition-duration: .5s;
}


.notificationArray p{
    display: flex;
    flex-direction: column;
    margin: 2px;
}

.close-shipment-info{
    width: 30px;
    height: 30px;
    margin-right: 5%;
    margin-top: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.close-shipment-info:hover{
    transition-duration: .5s;
    border-radius: 999px;
    background-color: #e4e4e4;
}

.pdf-render-container{
    margin-left: 5px;
    margin-right: 5px;
}

.print-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-left: 25px;
    /* margin-top: 5px; */
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.print-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.create-button{
    background-color: #33f18a;
    margin-left: 25px;
}

.create-button:hover{
    transition-duration: .5s;
    background-color: #31d77b;
}

.cancel-button{
    background-color: #fe804d;
    margin-left: 25px;
    margin-top: 5px;
}

.cancel-button:hover{
    transition-duration: .5s;
    background-color: #e27144;
}

.close-shipment-info-container{
    display: flex;
    justify-content: flex-end;
}

.return-to-sender-container{
    margin-left: 25px;
    margin-bottom: 15px;
    margin-top: 15px;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 25px;
    width: fit-content;
}

/* Full-screen overlay for product-based actions (Charge Same Day, Update Weight) so the
   ActivityProductTemplate panel is large and centered on top of the ShipmentInfo popup
   instead of squeezed inline. Keeps the existing inner markup/behavior unchanged. */
.shipment-action-overlay{
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    /* Below the LoadingData overlay (z-index 99) so the loading animation shows on top when
       charging/updating, but above the ShipmentInfo popup (z-index 10). */
    z-index: 50;
    padding: 20px;
}

/* Override the inline-flow sizing so the panel is large and scrolls internally. Taller default
   height, and user-resizable (drag the bottom-right corner) within sensible min/max bounds. */
.shipment-action-overlay .shipment-action-overlay-panel{
    margin: 0;
    width: 90%;
    max-width: 1000px;
    height: 92vh;
    min-width: 400px;
    min-height: 400px;
    max-height: 96vh;
    overflow: auto;
    resize: both;
}

/* On phones, use the full width and drop the min-width so the panel never overflows the
   viewport. Also remove the backdrop padding to maximize usable space. */
@media (max-width: 600px) {
    .shipment-action-overlay {
        padding: 8px;
    }

    .shipment-action-overlay .shipment-action-overlay-panel {
        width: 100%;
        min-width: 0;
        height: 95vh;
        max-height: 95vh;
        resize: none;
    }
}

.action-group {
    margin-top: 0;
    margin-left: 0;
    padding: 6px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background-color: #fafafa;
}

.action-groups-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 10px 0 10px 25px;
}

.action-group-danger {
    border-color: #f5c6c6;
    background-color: #fff8f8;
}

.action-group-title {
    margin: 0 0 4px;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #555;
}

.action-group-danger .action-group-title {
    color: #9d2525;
}

.action-group-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.action-group-buttons .print-button {
    margin: 0;
    padding: 4px 8px;
    font-size: 11px;
    white-space: nowrap;
}

.activity-product-collapsible {
    margin: 8px 8px 8px 25px;
    border: 1px solid #d5e0ea;
    border-radius: 8px;
}

.activity-product-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    border: none;
    border-radius: 8px 8px 0 0;
    background-color: #eef3f8;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: #38546e;
    text-align: left;
}

.activity-product-toggle:hover {
    background-color: #dfe9f2;
}

.activity-product-badge {
    padding: 2px 6px;
    border-radius: 10px;
    background-color: #33f18a;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
}

.activity-product-panel {
    padding: 10px;
    border-top: 1px solid #d5e0ea;
    max-height: 300px;
    overflow-y: auto;
}

.activity-product-panel :deep(.activity-product-container) {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-top: 0;
}

.activity-product-panel :deep(.activity-selector) {
    position: static;
    padding: 12px;
}

.activity-product-panel :deep(.activity-list) {
    max-height: 120px;
}

.activity-product-panel :deep(.product-section) {
    padding: 12px;
}

.activity-product-panel :deep(.product-list) {
    margin-top: 10px;
    gap: 10px;
}

/* When shown inside the resizable overlay, let the inner ActivityProductTemplate grow to fill
   the taller panel instead of being capped at the small inline max-heights. The overlay panel
   becomes a flex column so the collapsible + its scroll area take the remaining height. */
.shipment-action-overlay .shipment-action-overlay-panel {
    display: flex;
    flex-direction: column;
}

.shipment-action-overlay .activity-product-collapsible {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.shipment-action-overlay .activity-product-panel {
    flex: 1;
    max-height: none;
    min-height: 0;
}

/* Let the two-column layout (activity list | product details) use the full width/height.
   Only force two columns on wider screens — on mobile the component's own media query stacks
   it vertically, so scope this override above the 800px breakpoint. */
.shipment-action-overlay .activity-product-panel :deep(.activity-product-container) {
    height: 100%;
}

@media (min-width: 801px) {
    .shipment-action-overlay .activity-product-panel :deep(.activity-product-container) {
        grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);
    }
}

.shipment-action-overlay .activity-product-panel :deep(.activity-list) {
    max-height: none;
}

.activity-product-footer {
    padding: 6px 12px;
    border-top: 1px solid #d5e0ea;
    background-color: #f8fafc;
    border-radius: 0 0 8px 8px;
}

.geocode-url-container {
    margin: 10px 16px 0 16px;
    padding: 12px 20px;
    border: 1px solid #d5e0ea;
    border-radius: 8px;
    background-color: #f8fafc;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.geocode-url-label {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
}

.geocode-url-notice {
    margin: 0;
    font-size: 11px;
    line-height: 1.5;
    color: #64748b;
    background-color: #eef4fb;
    border-left: 3px solid #32ccfe;
    border-radius: 4px;
    padding: 8px 10px;
}

.geocode-url-notice .fa-info-circle {
    color: #32ccfe;
    margin-right: 4px;
}

.geocode-url-input {
    padding: 8px 10px;
    font-size: 13px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
}

.geocode-url-input:focus {
    border-color: #32ccfe;
}

/* History Check Mark */
.inner-history-container p{
    margin: 0;
}

.inner-history-container{
  border: 1px solid #b3b3b3;
  border-radius: 15px;
  padding: 15px;
  margin: 15px;
  margin-left: 12.5%;
  width: 50%;
}

.history-container{
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.check-mark.active{
  background: linear-gradient(
    to bottom, 
    #ffffff 0%, 
    #ffffff 50%, 
    #33f18a 50%, 
    #33f18a 100%
  );
}

.check-mark.activeLast{
  background: linear-gradient(
    to top, 
    #ffffff 0%, 
    #ffffff 50%, 
    #33f18a 50%, 
    #33f18a 100%
  );
}

.main-button-blue-white{
    padding-top: 5px;
    padding-bottom: 5px;
}

.image-container {
  width: 40%;
  max-width: 300px;
  overflow: hidden;
  display: flex; 
  justify-content: center;
  resize: both;
}

.proof-delivery-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  width: 100%; 
    height: 100%; 
    border: none; 
    display: block; 
    margin-bottom: 20px;
    border-radius: 25px;
}

.overlay-container{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 50%; 
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  z-index: 1000;
  text-align: center;
  height: 65vh;
  width: 90vw;
  border-radius: 25px;
}

.overlay button{
  position: fixed;
  top: -40px; 
  left: 5px;
  border: none;
  cursor: pointer;
  background-color: #32ccfe;
  color: #fff;
  padding: 10px 15px;
  border-radius: 99px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  transition-duration: .25s;
  font-size: 12px;
}

.overlay button:hover{
  background-color: #2ebae9;
  transition-duration: .25s;
}

.overlay a{
  position: fixed;
  top: -40px; 
  left: 150px;
  border: none;
  cursor: pointer;
  background-color: #e0e0e0;
  color: #000;
  padding: 10px 15px;
  border-radius: 99px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  transition-duration: .25s;
  text-decoration: none;
  font-size: 12px;
}

.overlay a:hover{
  background-color: #cfcfcf;
  transition-duration: .25s;
}

.proof-delivery-container{
  display: flex;
  flex-direction: column;
}

.proof-delivery-container button{
  width: 140px;
  margin-bottom: 5px;
  margin-top: 5px;
}

.check-mark{
  background-color:#33f18a;
  color: #fff;
  width: 2.5px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 4;
}

.check-mark-item{
  width: 30px;
  height: 30px;
  border-radius: 50px;
  background-color: #33f18a;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.check-mark-item img{
  width: 20px;
}

.check-mark-container{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}

.history-description{
  font-weight: bold;
}

.history-process-date{
  background: #f0f0f0;
  color: #858585;
  border-radius: 2.5px;
  padding: 2px;
}

.history-description-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.label-container{
    margin-top: 5px;
    width: 100%;
}

@media only screen and (max-width: 820px){
    .confirm-container-main{
        width: 90%;
    }

    .weight-container{
        background-color: #fff;
        margin: 5px 15px;
        width: fit-content;
    }

    .confirmContainerInner{
        flex-direction: column;
        flex-wrap: wrap;
    }

    .confirmContainerInner1, .confirmContainerInner2{
        width: fit-content;
    }

    .package-details-header{
        font-size: 1.6em;
    }

    .inner-history-container{
        margin: 15px;
        margin-left: 12.5%;
        width: 70%;
    }
}
</style>